/**
 * Common constants to be used throughout the project
 */
// Import ROLES and TIERS from roleConstants as single source of truth
import { ROLES, TIERS } from './roleConstants';
import introImg from "../../assets/images/intro_user_manual.png";
import orderflowImg from "../../assets/images/manual/orderflow.jpg";
import marketProfileImg from "../../assets/images/manual/market-profile.jpg";
import mpOldImg from "../../assets/images/mp-chart.png";
import optTableImg from "../../assets/images/manual/options-table.jpg";
import smartCCImg from "../../assets/images/manual/smart-candlesticks.jpg";
import spectrumImg from "../../assets/images/manual/spectrum.jpg";
import ntmVolxImg from "../../assets/images/manual/ntm-volx.jpg";
import ntmOIImg from "../../assets/images/manual/ntm-oi.jpg";
import gammaImg from "../../assets/images/manual/gamma-plot.jpg";
import wcashImg from "../../assets/images/manual/wcash-charts.jpg";
import mpOfDualImg from "../../assets/images/manual/mp_of.jpg";
// import introImg from '../../assets/images'

export const CONSTANTS = {
    FIXED_HEADER_HEIGHT:32,
    FIXED_FOOTER_HEIGHT:32,
    DASHBOARD_HEADER_HEIGHT:48,
    FIXED_RIGHT_PANEL_WIDTH:50
}

export const TEXT_MSGS={
    NETWORK_ERROR_MSG:"Oops! Looks like there is a temporary outage due to a drop in connectivity. Should get resolved soon. Please try again in few minutes!",
    MERGE_ERROR:"You can merge only the adjacent profiles.",
    UNMERGE_NOT_ALLOWED:"Monthly/Yearly Profile unmerge is not supported right now.",
    USER_SETTINGS_SAVED:"User details updated successfully.",
    SUBSCRIPTION_POPUP_TITLE:"Premium",
    // ============================================================
    // UPDATED - Changed "Expert" to "Premium" for 3-tier system
    // See: CENTRALIZED_PERMISSION_SYSTEM_COMPLETE_SUMMARY.md
    // ============================================================
    SUBSCRIPTION_PRO_POPUP_TITLE:"Premium or higher plan",
    SUBSCRIPTION_POPUP_DESC:"This feature is available only to our premium users right now.",
    LIVE_PANEL_NOT_SUPPORTED:"Live panel only supported in full chart view.",
    LIVE_PANEL_NOT_SUPPORTED_LC:"Live panel only supported for market profile chart",
    MARKET_NOT_LIVE:"Market is not live.",
    POSITION_SAVED_SUCCESS:"Position is saved successfully.",
    POSITION_DELETED_SUCCESS:"Position is deleted successfully.",
    POSITION_NOTHING_TO_SAVE:"There is no non zero position to save.",
    BOOKMARK_SAVED_SUCCESS:"Bookmark is saved successfully.",
    CHART_SAVED_SUCCESS:"Saved successfully.",
    CHART_SAVE_NOT_ALLOWED_LIVE_COMPOSITE:"Can't save the chart. Please unmerge the live composite before saving the chart.",
    BOOKMARK_SAVE_NOT_ALLOWED_LIVE_COMPOSITE:"Can't save the chart. Please unmerge the live composite before saving the chart.",
    BOOKMARK_DELETED_SUCCESSFULLY:"Bookmark deleted.",
    BOOKMARK_EDITED_SUCCESSFULLY:"Bookmark edited.",
    BOOKMARK_OVERWRITTEN_TITLE:"Overwrite bookmark",
    BOOKMARK_OVERWRITTEN_DESC:"Bookmark is not up to date. Do you want to overwrite it as per the current chart state?",
    CLEAR_AUTOSAVED_TITLE:"Clear Saved State",
    CLEAR_AUTOSAVED_BOOKMARK:"Do you want to clear the saved chart state?",
    CLEAR_AUTOSAVED_BOOKMARK_SUCCESS:"Chart state is reset successfully",
    USER_DETAILS_UPDATED_SUCCESSFULLY:"Contact details updated successfully",
    PASSWORD_UPDATED_SUCCESSFULLY:"Password is updated successfully",
    // ============================================================
    // UPDATED - Changed "Expert" to "Premium" for 3-tier system
    // See: CENTRALIZED_PERMISSION_SYSTEM_COMPLETE_SUMMARY.md
    // NOTE: Phase 5 will replace this with permissions.getUpgradeMessage(feature)
    // ============================================================
    PREMIUM_PLUS_UPGRADE_MSG:"Upgrade to a Professional or Elite plan to get access to advanced features and gain edge in your trading with our proprietary Market and Inventory Visualizations and Spectrum charts.",
    PREMIUM_PLUS_UPGRADE_ORDERFLOW_MSG:"Upgrade to an Elite plan to get access to our unique Orderflow charts with proprietary tools and gain edge in your trading.",
    MAX_ALLOWED_STRIKES:"Maximum 3 strikes can be selected.",
    CHART_DATA_NOT_AVAILABLE:"No data found for the selected options.",
    ERROR_MSG_TABLE_NO_DATA:"No data found.",
    MULTICHART_NOT_SUPPORTED:"Multichart is not supported on small screen devices",
    SET_LEVEL_TITLE:"Freeze Levels",
    SET_LEVEL_DESC:"This action will load a fresh chart that shows profiles overlapping the selected region only.\nDo you want to freeze the levels and plot the chart?",
    DELETE_LEVEL_TITLE:"Delete selected level",
    DELETE_LEVEL_DESC:"Deleting the level selection may reset the current chart back to normal.\n Do you want to continue?",
    LINE_CHART_LIVE_DATA_DELAY:"Please wait 2 minutes for the live data to start flowing..",
    MP_CHART_STOCK_RESOURCE_NOT_SUBSCRIBED_DESC:"Please subscribe to Stocks FnO to access the Stocks MP chart",
    OF_CHART_INDEX_RESOURCE_NOT_SUBSCRIBED_DESC:"Please subscribe to Orderflow for Index FnO or  Orderflow for All FnO to access Index Orderflow Chart",
    OF_CHART_STOCKS_RESOURCE_NOT_SUBSCRIBED_DESC:"Please subscribe to Orderflow for All FnO to access Stocks Orderflow Chart",
    MP_STOCKS_ADD_ONS_NOT_SELECTED:"Please select the Stocks FnO to upgrade your existing Premium subscription",
    OF_STOCK_INDEX_ADD_ONS_NOT_SELECTED:"Please select Orderflow for Index or Orderflow for All FnO to upgrade your existing Premium + subscription",
    DELETE_KRL_TITLE:"Delete KRL",
    DELETE_KRL_DESC:"You sure you wish to delete KRL at Level: ",
    DELETE_KRL_DESC_ANCHORED:"You sure you wish to delete the selected Anchored KRL?",
    SAVE_EDIT_BOOKMARK_NOT_ALLOWED_FROM_OTHER_USER:"Oops! you are not allowed to change data in someone else's bookmark.",
    BROKER_AUTHENTICATION_SUCCESS:"Broker integration is done successfully",
    MULTICHART_3_COLS_NOT_SUPPORTED:"Unable to render 3 column view due to smaller screen size",
    LOGIN_POPUP_MSG:"Session expired. Please login again to continue.",
    INTERNET_ERROR_MESSAGE:"Oops! Looks like you went offline. Please check your internet connection and try again.",
    MP_NO_DATA:"No data found for the selected instrument.",
    BOOKMARK_NOT_FOUND:"Bookmark doesn't exist",
    DELETE_BOOKMARK_TITLE:"Delete Bookmark",
    DELETE_BOOKMARK_MSG:"Do you want to delete the bookmark?",
    ELITE_UPGRADE_MSG:"Upgrade to a Elite plan to get access to advanced features and gain edge in your trading with our proprietary Market and Inventory Visualizations and Spectrum charts.",
    BOOKMARK_ACTION_NOT_ALLOWED:"You are not authorized to perform this action.",
    MSG_NOTIFICATION_ENABLED:"(Notifications will be enabled for this browser after you Save the settings. Make sure your browser security settings allow Push Notifications to be received.)",
    MSG_NOTIFICATION_DISABLED:"(Notifications will stop after you Save the settings.)",
    INFO_BROWSER_NOTIFICATION_POP_UP:`Enable/Disable push notifications for this browser. Changes will take effect only after you click on "Save Settings" button below.`,
    WATCHLIST_CREATED:"Watchlist created successfully",
    WATCHLIST_RENAMED:"Watchlist renamed successfully",
    WATCHLIST_DELETED:"Watchlist deleted successfully",
    MAXIMUM_ALLOWED_INSTRUMENT_IN_WATCHLIST:" instruments limit exceeded in watchlist.",
    MAX_WATCHLIST_ALLOWED:" watchlists allowed per user.",
    WATCHLIST_PANEL_NOT_SUPPORTED:"Watchlist only supported in single or dual chart view.",
    CONFIRM_BOOKMARK_SAVE_AND_CONTINUE_WATCHLIST_OPENING_TITLE:"Bookmark Changed",
    CONFIRM_BOOKMARK_SAVE_AND_CONTINUE_WATCHLIST_OPENING_MSG:"There are unsaved chnage to the bookmark. How do you want to proceed?",
    DELETE_WATCHLIST_TITLE:"Delete Watchlist",
    DELETE_WATCHLIST_MSG:"Do you want to delete the selected watchlist?",
    ORDERFLOW_CHART_NOT_AVAILABLE:"Orderflow chart is not availble for the selected instrument."


}

export const ELITE_UPGRADE_MSGS_LIST = [
    "Data Built for Professionals. Check Elite.",
    "Stay Ahead of the Curve with Elite Access and Orderflow chart access!",
    "Discover More Features, Discover More Success - Upgrade Now!",
    "Your Trading Deserves More - Go Elite Today!",
    "Experience the Best in Trading with our proprietary Orderflow charts - Become an Elite Member!",
    "Indices Futures and Options with all Stocks FnO — all in one place with Elite plan.",
    "Don't Settle for Less. Unleash Full Potential with Elite!",
    "Trade Like a Pro, in Real-Time with Elite plans. Upgrade Now!",
    "Never Miss a Trading Opportunity Again - Upgrade Now!",
    "Fine-Tune Your Trades with Gamma Charts - Upgrade Today!",
    "Work with Gamma Like a Pro - Upgrade to Elite!",
    "Discover the Power of Live Gamma - Upgrade to Elite!",
    "Experience Full Spectrum of Trading - Go Elite Now!",
    "Trade Smarter with Gamma Charts - Go Elite Now!",
    "Harness the Power of Live Data & Spectrum - Upgrade to Elite Today!",
]

export const PREMIUM_UPGRADE_MSGS_LIST = [
    "Go Professional, Gain Faster Data - Right Now!",
    "Go Elite, Gain Live Data - Right Now!",
    "Data Built for Professionals. Check Elite.",
    "Time is Money - Don't Settle for Delays. Upgrade Now!",
    "Stay Ahead of the Curve with Professional tier Access and Faster Data!",
    "Stay Ahead of the Curve with Elite Live Data and Orderflow chart access!",
    "Why Wait 15 Minutes? Get Faster Data with Professional tier!",
    "Why Wait 15 Minutes? Get Live-Data direct from NSE with Elite!",
    "Discover More Features, Discover More Success - Upgrade Now!",
    "Leave Delay Behind. Enter the Fast Lane with Professional tier!",
    "Your Trading Deserves More - Go Professional Today!",
    "Experience the Best in Trading - Become a Professional Member!",
    "Experience the Best in Trading with our proprietary Orderflow charts - Become an Elite Member!",
    "Indices Futures and Options with all Stocks FnO — all in one place with Elite plan.",
    "Don't Settle for Less. Unleash Full Potential with Professional plan!",
    "Live Data, Advanced Tools, More Wins - Upgrade Today!",
    "Why Limit Yourself? Enjoy 10,000+ live instruments straight from NSE, with Elite!",
    "Trade Like a Pro, in Real-Time with Elite plans. Upgrade Now!",
    "Never Miss a Trading Opportunity Again - Upgrade Now!",
    "Get Spectrum on Your Side - Upgrade to Expert!",
    // "Catch Every OI Change Live - Go Premium Now!",
    "Trade Smarter with Real-Time Data direct from NSE in Elite plans",
    "Fine-Tune Your Trades with Gamma Charts - Upgrade Today!",
    "Work with Gamma Like a Pro - Upgrade to Elite!",
    "Experience Real-Time OI Changes - Go Elite Now!",
    "Live Data, Spectrum Access, More Success - Upgrade Today!",
    "Discover the Power of Live Gamma - Upgrade to Elite!",
    // "Unlock Real-Time OI Changes - Become a Premium Member Today!",
    "Get an Edge with Real-Time Spectrum data Access - Upgrade to Elite Now!",
    // "Tune Into Live Market Changes with Premium - Upgrade Today!",
    "Experience Full Spectrum of Trading - Go Elite Now!",
    // "Stay on Top of Live OI Changes - Upgrade to Premium!",
    "Trade Smarter with Gamma Charts - Go Expert Now!",
    "Harness the Power of Live Data & Spectrum - Upgrade to Elite Today!",
]

// This maintains compatibility with existing code while using roleConstants as source of truth
export const USER_ROLE_FIELDS={
    BASIC: ROLES.BASIC,
    PREMIUM: ROLES.PREMIUM,
    PRO1: ROLES.PRO1,
    PRO2: ROLES.PRO2,
    ADMIN: ROLES.ADMIN,
    ORDERFLOW:'orderflow'  // Keep this as it's not in ROLES
}

export const PREVIEW_IN_PROGRESS="in_progress"

// ==================== ROLE HIERARCHY CONSTANTS ====================
// Define tier constants first (used by feature-specific role arrays below)
// Hierarchy: BASIC < PREMIUM < PRO1 (Elite) < PRO2 < ADMIN
// PRO1 (Elite) is higher than PREMIUM, PRO2 is higher than PRO1
// Premium tier and above (premium role OR pro1 role OR pro2 role)
export const ALLOWED_ROLES_PREMIUM=[ROLES.PREMIUM, ROLES.PRO1, ROLES.PRO2];
// Elite tier only (pro1 role OR pro2 role)
export const ALLOWED_ROLES_ELITE=[ROLES.PRO1, ROLES.PRO2];
export const ALLOWED_ROLES_PRO2=[ROLES.PRO2];

// ==================== FEATURE-SPECIFIC ROLE ARRAYS ====================
// Use tier constants to reflect hierarchy (PRO2 > PRO1 > PREMIUM > BASIC)
export const DATE_PICKER_ALLOWED_ROLES=[ROLES.ADMIN, ...ALLOWED_ROLES_PREMIUM];
export const PREVIEW_BUTTON_ALLOWED_ROLES=[ROLES.PRO1, ROLES.PRO2]; // Elite only
export const DRAWING_TOOL_ALLOWED_ROLES=[ROLES.ADMIN, ...ALLOWED_ROLES_PREMIUM];
export const WATCHLIST_ALLOWED_ROLES=[ROLES.ADMIN, ...ALLOWED_ROLES_PREMIUM];
export const WATCHLIST_TABLE_SETTINGS_KEY="watchlist_table_settings"; //stores user preference in session storage

export const USER_RESOURCES_LIST={
    MP_INDEX:"mp_index",
    BSE_MP_INDEX:"bse_mp_index",
    TBT_FEED:"tbt_data",         // Fast per second polling
    ONE_MIN_DATA:"1min_data",    // Slow per minute polling - NEW
    MP_STOCKS:"mp_stocks",
    OF_INDEX:"orderflow_index",
    BSE_OF_INDEX:"bse_orderflow_index",
    OF_STOCKS:"orderflow_stocks",
    E_COURSE:"vmr_ecourse",
    BROWSER_PUSH:"browser_push"

}

export const CHART_RELOAD_TIME={
    SLOW_DATA:60*1000,  //1min  reload
    FAST_DATA:1100,     //1.1sec reload
    LC_DATA:10*1000,    // 25 seconds reload - make sure to reload at least twice in same minute - slow polling due to performance issue
    POLLING_TIME:5*60*1000, //5mins
    // POLLING_TIME:10*1000,
    OPTIONS_DATA:8*1000,     //8 seconds - it is a slow process approx 0.6 sec
    GREEKS_DATA:5*1000,      //5 seconds - greeks data is takes 2 secs to process normally - with caching it takes less than a second - needs further optimisation
    INDEX_DATA_FAST:4*1000,  //4 seconds - index data actually can be 1 second refresh too - takes few ms to get record.
    TICKER_DATA_FAST:2000,   //locally it takes more than 1 sec for update sometimes - causing cancellation issues - will do slow polling till issue fix.
    INDEX_DATA_SLOW:70*1000,
    STRIKES_RELOAD_TIME:30*60*1000, //30mins
    // STRIKES_RELOAD_TIME:10*1000 //test 10sec
    FAST_POLLING:60*1000    //1min polling for market status check  
}


export const MP_CHART_RELOAD_TIME={
    DELAYED_DATA:15*60*1000,  //15 minutes reload - NEW: Free users without resources
    SLOW_DATA:70000,          //70 seconds reload (deprecated, use DELAYED_DATA for free users)
    MINWISE_DATA:60*1000,     //1 minute reload - NEW: Premium users with 1min_data
    FAST_DATA:1100,           //1.1sec reload - Elite users with tbt_data
    POLLING_TIME:5*60*1000,   //5mins polling
    // POLLING_TIME:30*1000, //5mins polling
    FAST_POLLING:60*1000,     //1min polling for market status check    
    KRL_POLLING_TIME:5*60*1000, //5mins polling  
    FAST_KRL_POLLING_TIME:1*60*1000, //1mins polling  
}


export const RESEND_TIMER_VAL=120; //120 seconds
export const OTP_RESEND_TIMER_VAL=60; //60 seconds - matches backend RESEND_OTP_TIME

export const SNACKBAR_AUTO_HIDE_DURATION=5000;  //5seconds
export const SNACKBAR_AUTO_HIDE_DURATION_SHORT=2000;  //5seconds
export const MIN_WIDTH_3_COLS=1920;
export const  REFRESH_POLLING_INTERVAL=2000;
export const NOTIFICATION_POLLING_INTERVAL=5000;    //5seconds notification polling
export const WATCHLIST_POLLING_INTERVAL=5000; 

export const TIME_FRAME_VALUES={
    daily:"daily",
    weekly:"weekly",
    weekly_series:"weekly_s",
    monthly:"monthly",
    monthly_series:"monthly_s",
    yearly:"yearly_d"
}
export const PROFILE_VIEW={
    tpo_only:"TPO_ONLY",
    vol_tpo_side:"VOL_TPO_SIDE",
    only_vol:"VOL_ONLY",
    tpo_on_vol:"TPO_ON_VOL",
 }

//  export const CANDLE_BOTTOM_COL={
//     vol:"vol",
//     cot:"cot",
//     doi:"doi",
//  }

 export const AUTO_CENTER_CONFIG={
    DELAY:1000,  //throttle/debounce delay
    THROTTLING:1,
    DEBOUCE:2,
    USE_THROTTLE_OR_DEBOUNCE:1,     //1 for throttling based auto center, 2 for debounce based
    DELTA_X:10,                     //represent x translation required to trigger auto center
    DELTA_Y:20                      //less than this value required for auto centering otherwise user is vertically scrolling so dont trigger auto center here
 }

 export const WATERMARK_CONFIG={
    TEXT:"© 2026 Vtrender™ Charts",
    TABLE_TEXT:"© 2026 Vtrender™ Charts",
    LC_TEXT:"© 2026 Vtrender™ Charts"
 }

// ==================== GENERAL ROLE ARRAYS ====================
// allowed roles are the selected and above roles (for hierarchy considerations)
// admin is not ideally hierarchial, but some pages are xclusive only to admin user
// New plan structure: basic, premium, pro1 (Elite tier), pro2
// Backward compatibility removed - only new role names are used
// All role arrays use ROLES constants for single source of truth
export const ALL_USER_ROLES=[ROLES.BASIC, ROLES.PREMIUM, ROLES.PRO1, ROLES.PRO2, ROLES.ADMIN];
export const ALLOWED_ROLES_ALL=ALL_USER_ROLES;
export const ALLOWED_ROLES_ADMIN=[ROLES.ADMIN];
// Orderflow features require Elite tier (pro1 role OR pro2 role)
export const ALLOWED_ROLES_ORDERFLOW=[ROLES.PRO1, ROLES.PRO2];
export const ALLOWED_ROLES_ORDERFLOW_PREVIEW=[ROLES.PREMIUM];

 export const RESOURCE_LIST={
    ORDERFLOW:[USER_RESOURCES_LIST.OF_INDEX, USER_RESOURCES_LIST.OF_STOCKS]
 }
export const RESOURCE_LIST_TBT=[USER_RESOURCES_LIST.TBT_FEED]


export const  LOCALE_STRING="en-IN" ;

export const BOOKMARKT_CATEGORY_DATA=[
    {
        name:"New",
        value:"New"
    },
    {
      name:"Options",
      value:"Options"
    },
    {
      name:"Futures",
      value:"Futures"
    },
  ]

  export const BOOKMARK_NAME_MAX_LENGTH=30;
  export const BOOKMARK_CATEGORY_MAX_LENGTH=30;
  export const BOOKMARK_CATEGORY_AUTOSAVE="AUTO_SAVED";
  export const BOOKMARK_AUTO_SAVE_DURATION=3*60*1000;             //3mins
  export const ERROR_CODE_BOOKMARK_ALREADY_MODIFIED=307;
  export const WATCHLIST_NAME_MAX_LENGTH=40;

  export const DateFormat = 'DD-MM-YYYY';
  
  const ITEM_HEIGHT = 26;
  const ITEM_PADDING_TOP = 8;
  export const MenuProps = {
    PaperProps: {
      style: {
        maxHeight: ITEM_HEIGHT * 10 + ITEM_PADDING_TOP,
        width: 80,
        autoFocus: false
      },
    },
  };
 
  export const NO_OF_DAYS=[
    {
        key:"Intra Only",
        value:-1
    },
    {
        key:1,
        value:1
    },
    {
        key:2,
        value:2
    }, 
    {
        key:3,
        value:3
    },    
    {
        key:4,
        value:4
    },
    {
        key:5,
        value:5
    },    
    {
        key:6,
        value:6
    },    
]

export const HV_CHART_V_TYPES=[
    {
        key:"C2C Log Ratio Std Dev",
        value:"c2c_sigma"
    },
    {
        key:"C2O Log Ratio Std Dev",
        value:"c2o_sigma"
    },
    {
        key:"Gap Std Dev",
        value:"gap_sigma"
    },
    {
        key:"Day Range Std Dev",
        value:"o2c_sigma"
    },
    {
        key:"C2C Diff Std Dev",
        value:"c2cd_sigma"
    },
    {
        key:"C2C Log Ratio Mean",
        value:"c2c_mean"
    },
    {
        key:"C2O Log Ratio Mean",
        value:"c2o_mean"
    },
    {
        key:"Gap Mean",
        value:"gap_mean"
    },
    {
        key:"Day Range Diff Mean",
        value:"o2c_mean"
    },
    {
        key:"C2C Diff Mean",
        value:"c2cd_mean"
    }
]

export const HV_CHART_PLOT_TYPES=[
    {
        key:"ATR 5",
        value:"5_atr"
    },
    {
        key:"ATR 20",
        value:"20_atr"
    },
    {
        key:"ADR 5",
        value:"5_adr"
    },
    {
        key:"ADR 20",
        value:"20_adr"
    },
]

export const HV_OI_TYPES=[
    {
        key:"COI",
        value:"coi"
    },
    {
        key:"dCOI",
        value:"dcoi"
    },
    {
        key:"Volume",
        value:"vol"
    },
]

export const SNAKE_CHART_PLOT_TYPE=[
    {
        key:"Multi Strike Straddle Price",
        value:"pair_price"
    },
    {
        key:"Multi Strike Straddle OI",
        value:"oi"
    },
    {
        key:"Multi Strike IV and Writers' Cash",
        value:"iv_wcash"
    },
    {
        key:"Synthetic Futures",
        value:"synth_fut"
    },
    
]

// this menu is for admin and pro_2
export const BAR_CHART_PLOT_TYPE=[
    {
        key:"Strike Available Intra Value - Split",
        value:"_gcash"
    },
    {
        key:"Strike Available Total Value - Split",
        value:"_dgcash"
    },
    {
        key:"Writers' Cash - Split",
        value:"_wcash"
    },
    {
        key:"OI - Split",
        value:"_oi"
    },
    {
        key:"OI Change - Split",
        value:"_doi"
    },
    {
        key:"Volume - Split",
        value:"_vol"
    },
    {
        key:"IV - Split",
        value:"_iv"
    },
    {
        key:"Strike Available Intra Value - Net",
        value:"net_gcash"
    },
    {
        key:"Strike Available Total Value - Net",
        value:"net_dgcash"
    },
    {
        key:"Strike Available Intra Value - Sum",
        value:"total_gcash"
    },
    {
        key:"Strike Available Total Value - Sum",
        value:"total_dgcash"
    },
    {
        key:"Put Call Ratio",
        value:"pcr"
    },
    {
        key:"OI Difference - (Call OI - Put OI)",
        value:"net_oi"
    },
    {
        key:"Straddle OI - Sum",
        value:"total_oi"
    },
    {
        key:"Straddle Value",
        value:"straddle"
    },
    {
        key:"OI Pain Value",
        value:"oi_pain"
    },
    {
        key:"IV",
        value:"iv"
    },
]

// this is Options Strikewise OI Visualization menu for premium users
export const BAR_CHART_OI_PLOT_TYPE=[
    {
        key:"OI - Split",
        value:"_oi"
    },
    {
        key:"OI Change - Split",
        value:"_doi"
    },
    {
        key:"OI Difference - (Call OI - Put OI)",
        value:"net_oi"
    },
    {
        key:"Straddle OI - Sum",
        value:"total_oi"
    },
    {
        key:"Volume - Split",
        value:"_vol"
    },
    {
        key:"IV - Split",
        value:"_iv"
    },
    {
        key:"OI Pain Value",
        value:"oi_pain"
    },
    {
        key:"IV",
        value:"iv"
    },
]

// this menu is for admin
export const BAR_CHART_ADMIN_PLOT_TYPE=[
    {
        key:"Inventory Resistance Estimate - Sum",
        value:"total_dgcash"
    },
    {
        key:"Inventory Resistance Estimate - Net",
        value:"net_dgcash"
    },
    {
        key:"Inventory Resistance Estimate - Split",
        value:"_dgcash"
    },
    {
        key:"Gamma Exposure Value - Sum",
        value:"total_gcash"
    },
    {
        key:"Gamma Exposure Value - Net",
        value:"net_gcash"
    },
    {
        key:"Gamma Exposure Value - Split",
        value:"_gcash"
    },
    // {
    //     key:"Inventory Value - Sum",
    //     value:"total_ngex"
    // },
    // {
    //     key:"Inventory Value - Split",
    //     value:"_ngex"
    // },
    {
        key:"Gamma Value - Sum",
        value:"total_igex"
    },
    {
        key:"Gamma Value - Split",
        value:"_igex"
    },
    {
        key:"Writers' Cash - Split",
        value:"_wcash"
    },
    {
        key:"Gamma Density",
        value:"gd_curves"
    },
    {
        key:"Gamma Exposure",
        value:"gamma_curves"
    },
    {
        key:"GEX Curves",
        value:"gex_curves"
    },
]

// this is Options Strikewise Market Inventory Visualization menu, mainly for premium plus users
export const BAR_CHART_MI_PLOT_TYPE=[
    // {
    //     key:"Gamma Exposure Value - Sum",
    //     value:"total_gcash"
    // },
    // {
    //     key:"Gamma Exposure Value - Split",
    //     value:"_gcash"
    // },
    // {
    //     key:"Inventory Value - Sum",
    //     value:"total_ngex"
    // },
    // {
    //     key:"Inventory Value - Split",
    //     value:"_ngex"
    // },
    {
        key:"Gamma Value - Sum",
        value:"total_igex"
    },
    {
        key:"Gamma Value - Split",
        value:"_igex"
    },
    {
        key:"Writers' Cash - Split",
        value:"_wcash"
    },
    {
        key:"Gamma Density",
        value:"gd_curves"
    },
    {
        key:"Gamma Exposure",
        value:"gamma_curves"
    }
]


export const MARKET_OPEN_TIME="09:15";  // TODO: Remove UI Hardcoding
export const MARKET_CLOSE_TIME="15:30";  // TODO: Remove UI Hardcoding

export const TABLE_TYPES={
    INDEX_COMPONENTS:"INDEX_COMPONENTS",
    INDEX_FUT_COMPONENTS:"INDEX_FUT_COMPONENTS",
    OPTCHAIN:"OPTCHAIN",
    INDEX_TICKER:"INDEX_TICKER"
}

export const INDEX_TICKER_COLUMNS_LIST={
    spot_3D_comp_va:"spot_va",
    spot_open_high_low:"spot_open_high_low",
    spot_open_change_ltp:"spot_change",
    spot_timestamp:"spot_timestamp",
    fut_tr_atr:"fut_tr_atr",
    fut_open_high_low:"fut_open_high_low",
    hv_high_low:"hv_high_low",
    pe_chg_ltp:"pe_chg_ltp",
    fut_timestamp:"fut_timestamp",
    fut_prem_group:"fut_prem_group",
    prem_stats:"prem_stats",
    max_min_prem:"max_min_prem",
    sma_wma:"sma_wma",
    idx_ad:"idx_ad"
}

export const INDEX_COMPONENTS_COLUMNS_LIST={
    high:"high",
    low:"low",
    ltp:"ltp",
    change:"change",
    change_percent:"change_percent",
    tr:"tr",
    atr:"atr",
    avg_daily_vol:"avg_daily_vol",
    max_vol:"max_vol",
    wt_percent:"wt_percent",
    idx_change_pts:"idx_change_pts",
    change_ltp:"change_ltp",
    open_high_low:"open_high_low",
    value_area:"value_area",
    spot_chg:"spot_chg",
    netidxpts:"netidxpts",
    vol:"vol",
    tbcot:"tbcot",
    vol_vs_avg_vol:"vol_vs_avg_vol",
    percent_vol_tf_stats:"perc_vol_tf_stats",
    percent_avg_vol:"perc_avg_vol",
    max_daily_stats:"max_daily_stats",

 }

export const OPTCHAIN_COLUMNS_LIST={
    calls_max_min_oi:"min_max_oi",
    calls_doi_oi:"calls_doi_oi",
    calls_iv:"iv",
    calls_vol:"vol",
    calls_vpoc_vwap:"vpoc_vwap",
    calls_chg_ltp:"chg_ltp",
    puts_max_min_oi:"min_max_oi",
    puts_doi_oi:"calls_doi_oi",
    puts_iv:"iv",
    puts_vol:"vol",
    puts_vpoc_vwap:"vpoc_vwap",
    puts_chg_ltp:"chg_ltp",
    oi_spike:"oi_spike",
    straddle_pcr:"straddle_pcr",
    strike_pain:"strike_pain",
    synthetic_fut:"synthetic_fut"
}


export const SUBSCRIPTION_PLAN_LIST=[
    {
        key:"PREMIUM_MONTHLY_1",
        value:"PREMIUM_MONTHLY_1"
    },
    {
        key:"PREMIUM_MONTHLY_6",
        value:"PREMIUM_MONTHLY_6"
    },
    {
        key:"PREMIUM_MONTHLY_12",
        value:"PREMIUM_MONTHLY_12"
    },
    {
        key:"PREMIUM_PLUS_MONTHLY_1",
        value:"PREMIUM_PLUS_MONTHLY_1"
    },
    {
        key:"PREMIUM_PLUS_MONTHLY_6",
        value:"PREMIUM_PLUS_MONTHLY_6"
    },
    {
        key:"PREMIUM_PLUS_MONTHLY_12",
        value:"PREMIUM_PLUS_MONTHLY_12"
    },  
    {
        key:"PREMIUM_STOCKS_MONTHLY_1",
        value:"PREMIUM_STOCKS_MONTHLY_1"
    },
    {
        key:"PREMIUM_STOCKS_MONTHLY_6",
        value:"PREMIUM_STOCKS_MONTHLY_6"
    },
    {
        key:"PREMIUM_STOCKS_MONTHLY_12",
        value:"PREMIUM_STOCKS_MONTHLY_12"
    }, 
    {
        key:"PREMIUM_PLUS_ORDERFLOW_MONTHLY_1",
        value:"PREMIUM_PLUS_ORDERFLOW_MONTHLY_1"
    },
    {
        key:"PREMIUM_PLUS_ORDERFLOW_MONTHLY_6",
        value:"PREMIUM_PLUS_ORDERFLOW_MONTHLY_6"
    },
    {
        key:"PREMIUM_PLUS_ORDERFLOW_MONTHLY_12",
        value:"PREMIUM_PLUS_ORDERFLOW_MONTHLY_12"
    },   
    {
        key:"PREMIUM_PLUS_ORDERFLOW_STOCKS_MONTHLY_1",
        value:"PREMIUM_PLUS_ORDERFLOW_STOCKS_MONTHLY_1"
    },
    {
        key:"PREMIUM_PLUS_ORDERFLOW_STOCKS_MONTHLY_6",
        value:"PREMIUM_PLUS_ORDERFLOW_STOCKS_MONTHLY_6"
    },
    {
        key:"PREMIUM_PLUS_ORDERFLOW_STOCKS_MONTHLY_12",
        value:"PREMIUM_PLUS_ORDERFLOW_STOCKS_MONTHLY_12"
    },  
    {
        key:"ORDERFLOW_MONTHLY",
        value:"ORDERFLOW_MONTHLY"
    },
    {
        key:"ORDERFLOW_STOCKS_MONTHLY",
        value:"ORDERFLOW_STOCKS_MONTHLY"
    }
]   


export const PAYMENT_STATUS={
    SUCCESS:"success",
    CANCELLED:"cancelled",
    FAILURE:"failure",
    ERROR:"error"
}

export const MIN_CHART_WIDTH="630px";
export const MIN_SNAKE_CHART_WIDTH="1024px";
export const MIN_HV_CHART_WIDTH="1210px";
export const MIN_BAR_CHART_WIDTH="1024px";
export const MIN_TABLE_CONTAINER_WIDTH="1180px";


export const INSTRUMENT_POLLING_TIME=5*60*1000;         //5mins


/**
 * OF Related constants
 */

export const OF_CHART_RELOAD_TIME={
    SLOW_DATA:70000,      //70 seconds  reload
    FAST_DATA:1100,         //1.1sec reload
    POLLING_TIME:5*60*1000, //5mins polling
    // POLLING_TIME:30*1000, //5mins polling
    FAST_POLLING:60*1000    //1min polling for market status check        
}

export const OF_TIME_FRAME=[
    {
      key:1,
      value:"1",
      displayText:"1 min"
    },
    {
        key:3,
        value:"3",
        displayText:"3 mins"
      },
      {
        key:5,
        value:"5",
        displayText:"5 mins"
      },
      {
        key:15,
        value:"15",
        displayText:"15 mins"
      },
      {
        key:30,
        value:"30",
        displayText:"30 mins"
      },
  
  ]

  export const OF_TIME_FRAME_PRO2=[
      {
          key: 1,
          value: "1s",
          displayText: "1 sec"
      },
      {
          key: 3,
          value: "3s",
          displayText: "3 sec"
      },
      {
          key: 5,
          value: "5s",
          displayText: "5 sec"
      },
      {
          key: 15,
          value: "15s",
          displayText: "15 sec"
      },
      {
          key: 30,
          value: "30s",
          displayText: "30 sec"
      },
      {
          key: 1,
          value: "1",
          displayText: "1 min"
      },
      {
          key: 3,
          value: "3",
          displayText: "3 mins"
      },
      {
          key: 5,
          value: "5",
          displayText: "5 mins"
      },
      {
          key: 15,
          value: "15",
          displayText: "15 mins"
      },
      {
          key: 30,
          value: "30",
          displayText: "30 mins"
      },
  
  ]

  export const OF_TIME_FRAME_OTHER_D3_CHARTS=[
    {
      key:1,
      value:"1",
      displayText:"1 min"
    },
    {
        key:3,
        value:"3",
        displayText:"3 mins"
      },
      {
        key:5,
        value:"5",
        displayText:"5 mins"
      },
     
  
  ]
  export const OF_TIME_FRAME_STRADDLE_CHARTS=[
    {
      key:1,
      value:"1",
      displayText:"1 min"
    },
  ]
export const OF_TIME_FRAME_VALUES={
    tf_1_min:"1",
    tf_3_min:"3",
    tf_5_min:"5",
    tf_15_min:"15",
    tf_30_min:"30",
}

export const DEFAULT_OF_TIME_FRAME="3";

export const DEFAULT_CANDLE_TIME_FRAME="3";

export const OF_HIGHLIGHT_CONSTANT={
    VOL_THRESHOLD:5,
    BUY_HIGHLIGHT_MIN_RATIO:3,
    SELL_HIGHLIGHT_MIN_RATIO:3
}


export const SUBSCRIPTION_PLANS_PRICE={
    "monthly":{
        [TIERS.PREMIUM]:{
            "base":300,
            "base_gst":54,
            "stocks":400,
            "stocks_gst":72,
        },
        "premium_plus":{
            "base":1000,
            "base_gst":180,
            "orderflow":3000,
            "orderflow_gst":540,
            "orderflow_stocks":5000,
            "orderflow_stocks_gst":900,
        }
    },
    "quarterly":{
        [TIERS.PREMIUM]:{
            "base":855,
            "base_gst":162,
            "stocks":1995,
            "stocks_gst":378,
        },
        "premium_plus":{
            "base":2850,
            "base_gst":540,
            "orderflow":11400,
            "orderflow_gst":2160,
            "orderflow_stocks":17100,
            "orderflow_stocks_gst":3240,
        }
    },
    "half_yearly":{
        [TIERS.PREMIUM]:{
            "base":1911,
            "stocks":4460,
        },
        "premium_plus":{
            "base":6372,
            "orderflow":25488,
            "orderflow_stocks":38232,
        }

    },
    "annually":{
        [TIERS.PREMIUM]:{
            "base":2548,
            "stocks":5947,
        },
        "premium_plus":{
            "base":8496,
            "orderflow":33984,
            "orderflow_stocks":50976,
            
        }
    }
}

export const SUBSCRIPTION_PLANS={
    PREMIUM_MONTHLY_1_OLD:"PREMIUM_MONTHLY_1",
    PREMIUM_MONTHLY_6_OLD:"PREMIUM_MONTHLY_6",
    PREMIUM_MONTHLY_12_OLD:"PREMIUM_MONTHLY_12",
    PREMIUM_MONTHLY_1:"PREMIUM_INDEX_MONTHLY_1",
    PREMIUM_MONTHLY_3:"PREMIUM_INDEX_MONTHLY_3",
    PREMIUM_MONTHLY_6:"PREMIUM_INDEX_MONTHLY_6",
    PREMIUM_MONTHLY_12:"PREMIUM_INDEX_MONTHLY_12",
    PREMIUM_PLUS_MONTHLY_1:"PREMIUM_PLUS_MONTHLY_1",
    PREMIUM_PLUS_MONTHLY_3:"PREMIUM_PLUS_MONTHLY_3",
    PREMIUM_PLUS_MONTHLY_6:"PREMIUM_PLUS_MONTHLY_6",
    PREMIUM_PLUS_MONTHLY_12:"PREMIUM_PLUS_MONTHLY_12",
    PREMIUM_STOCKS_MONTHLY_1:"PREMIUM_INDEX_STOCKS_MONTHLY_1",
    PREMIUM_STOCKS_MONTHLY_3:"PREMIUM_INDEX_STOCKS_MONTHLY_3",
    PREMIUM_STOCKS_MONTHLY_6:"PREMIUM_INDEX_STOCKS_MONTHLY_6",
    PREMIUM_STOCKS_MONTHLY_12:"PREMIUM_INDEX_STOCKS_MONTHLY_12",
    PREMIUM_PLUS_ORDERFLOW_MONTHLY_1:"PREMIUM_PLUS_ORDERFLOW_INDEX_MONTHLY_1",
    PREMIUM_PLUS_ORDERFLOW_MONTHLY_3:"PREMIUM_PLUS_ORDERFLOW_INDEX_MONTHLY_3",
    PREMIUM_PLUS_ORDERFLOW_MONTHLY_6:"PREMIUM_PLUS_ORDERFLOW_INDEX_MONTHLY_6",
    PREMIUM_PLUS_ORDERFLOW_MONTHLY_12:"PREMIUM_PLUS_ORDERFLOW_INDEX_MONTHLY_12",
    PREMIUM_PLUS_ORDERFLOW_STOCKS_MONTHLY_1:"PREMIUM_PLUS_ORDERFLOW_INDEX_STOCKS_MONTHLY_1",
    PREMIUM_PLUS_ORDERFLOW_STOCKS_MONTHLY_3:"PREMIUM_PLUS_ORDERFLOW_INDEX_STOCKS_MONTHLY_3",
    PREMIUM_PLUS_ORDERFLOW_STOCKS_MONTHLY_6:"PREMIUM_PLUS_ORDERFLOW_INDEX_STOCKS_MONTHLY_6",
    PREMIUM_PLUS_ORDERFLOW_STOCKS_MONTHLY_12:"PREMIUM_PLUS_ORDERFLOW_INDEX_STOCKS_MONTHLY_12",
    ORDERFLOW_MONTHLY:"ORDERFLOW_INDEX_MONTHLY_1",
    ORDERFLOW_STOCKS_MONTHLY:"ORDERFLOW_INDEX_STOCKS_MONTHLY_1",
    STOCKS_MONTHLY_1:"STOCKS_MONTHLY_1",
    VMR_ECOURSE:"VMR_ECOURSE",
   
}  

 export const USER_MANUAL_TAB_LIST=[
    {
        value:0,
        name:"Vtrender™ Charts - Intro",
        id:"intro",
        title:"Vtrender™ Charts: The Triumvirate of Trading Excellence",
        // path:[],
        demoVideo:[
            {
                name: "Intro and Registration 1",
                src:"https://vimeo.com/854128544",
                yt_src: "https://youtu.be/QSy9oUdZxy8"
            }, 
            {
                name: "Intro and Registration 2",
                src:"https://vimeo.com/854262777",
                yt_src: "https://youtu.be/QSy9oUdZxy8"
            }, 
         ]
    },
    {
        value:1,
        name:"How-to in 5 min Videos",
        id:"intro_videos",
        title:"Intro Videos"
    },
    {
        value:2,
        name:"Orderflow Intro Videos",
        id:"orderflow_intro_videos",
        title:"Orderflow Intro Videos"
    },
    {
        value:3,
        name:"Market Profile Charts",
        id:"market_profile",
        path:["/market-profile"],
        title:"MarketProfile: The Blueprint of Trading Mastery",
        demoVideo:[
            {
                name: "Market Profile Charts 1",
                src:"https://vimeo.com/802425925",
                yt_src: "https://youtu.be/Nsu_GxDl02Q"
            },
            {
                name: "Market Profile Charts 2",
                src:"https://vimeo.com/802425925",
                yt_src: "https://youtu.be/LHtds-SrTi0"
            },
            
        ]

    },
    {
        value:4,
        name:"Orderflow Charts",
        id:"orderflow",
        path:["/orderflow"],
        title:"Demystifying OrderFlow: The Symphony of Market Dynamics",
        demoVideo:[
            {
                name: "Orderflow Charts 1",
                src:"https://vimeo.com/853735125",
                yt_src: "https://youtu.be/Ght8jNRidPo"
            },
            {
                name: "Orderflow Charts 2",
                src:"https://vimeo.com/853812666",
                yt_src: "https://youtu.be/Ght8jNRidPo"
            },
            
        ]
    },
    {
        value:5,
        name:"Options Table",
        id:"options_table",
        path:["/options-table"],
        title:"The Artistry of Option Tables: The Compass for Modern Traders",
        demoVideo:[
            {
                name: "Options Table 1",
                src:"https://vimeo.com/802425925",
                yt_src: "https://youtu.be/yp_EP2X41c4"
            },
            {
                name: "Options Table 2",
                src:"https://vimeo.com/802425925",
                yt_src: "https://youtu.be/NsTGNHKCd-I"
            },
            
        ]
    },{
        value:6,
        name:"Greeks Table",
        id:"greeks_table",
        path:["/greek-chart"],
        title:"The Alchemy of the Greeks Table: The Trader's Grimoire",
        demoVideo:[
            {
                name: "Greeks Table 1",
                src:"https://vimeo.com/802425925",
                yt_src: "https://youtu.be/3bll1e06vDo"
            },
            {
                name: "Greeks Table 2",
                src:"https://vimeo.com/802425925",
                yt_src: "https://youtu.be/NsTGNHKCd-I"
            },
            
        ]
    },{
        value:7,
        name:"Index Table",
        id:"index_table",
        path:["/index-table"],
        title:"Navigating the Index Galaxy: A Stellar Guide for Traders",
        demoVideo:[
            {
                name: "Index Table 1",
                src:"https://vimeo.com/802425925",
                yt_src: "https://youtu.be/ZcNnHieorVc"
            },
            {
                name: "Index Table 2",
                src:"https://vimeo.com/802425925",
                yt_src: "https://youtu.be/VkBMqJyqYcE"
            },
            
        ]
    },{
        value:8,
        name:"Spectrum Charts",
        id:"spectrum_charts",
        path:["/line-chart/NF_Options_Strike_Spectrum_Charts","/line-chart/BN_Options_Strike_Spectrum_Charts","/line-chart/FN_Options_Strike_Spectrum_Charts","/line-chart/MN_Options_Strike_Spectrum_Charts"],
        title:"Deciphering the Spectrum: Navigating Index Forecasts",
        demoVideo:[
            {
                name: "Spectrum Charts 1",
                src:"https://vimeo.com/802425925",
                yt_src: "https://youtu.be/_L5B9RhFPhc"
            },
            {
                name: "Spectrum Charts 2",
                src:"https://vimeo.com/802425925",
                yt_src: "https://youtu.be/G5n9__MxR24"
            },
            
        ]
    },{
        value:9,
        name:"OI Change Charts",
        id:"oi_change_charts",
        path:["/line-chart/NF_Options_OI_Change_Charts","/line-chart/BN_Options_OI_Change_Charts","/line-chart/FN_Options_OI_Change_Charts","/line-chart/MN_Options_OI_Change_Charts"],
        title:"Decoding Open Interest: Unveiling Market Pulse Through Moving Lines",
        demoVideo:[
            {
                name: "OI Change Charts 1",
                src:"https://vimeo.com/802425925",
                yt_src: "https://youtu.be/Z5gSyz68jKw"
            },
            {
                name: "OI Change Charts 2",
                src:"https://vimeo.com/802425925",
                yt_src: "https://youtu.be/SnTTzUDiVIY"
            },
            
        ]
    },{
        value:10,
        name:"NTM OI Change Charts",
        id:"ntm_oi_change_charts",
        path:["/line-chart/NF_Options_NTM_OI_Change_Charts","/line-chart/BN_Options_NTM_OI_Change_Charts","/line-chart/FN_Options_NTM_OI_Change_Charts","/line-chart/MN_Options_NTM_OI_Change_Charts"],
        title:"Zooming into Near Money Strikes: The Magnified Lens of OI Change",
        demoVideo:[
            {
                name: "NTM OI Change Charts 1",
                src:"https://vimeo.com/802425925",
                yt_src: "https://youtu.be/hItCJb7WX-M"
            },
            {
                name: "NTM OI Change Charts 2",
                src:"https://vimeo.com/802425925",
                yt_src: "https://youtu.be/Z5gSyz68jKw"
            },
            
        ]
    },{
        value:11,
        name:"Historical Volatility Charts",
        id:"historical_volatility_line_charts",
        path:["/hv-stock-chart/NIFTY","/hv-stock-chart/BANKNIFTY"],
        title:"Historical Volatility: Gazing Back to Navigate Forward",
        demoVideo:[
            {
                name: "HV Charts 1",
                src:"https://vimeo.com/802425925",
                yt_src: "https://youtu.be/TfyGzJYR2Zs"
            },
            {
                name: "HV Charts 2",
                src:"https://vimeo.com/802425925",
                yt_src: "https://youtu.be/419_jYo54cI"
            },
            
        ]
    },{
        value:12,
        name:"OI Inventory Visualization Charts",
        id:"oi_inventory_visualization_charts",
        path:["/bar-chart/NIFTY_Strike_OI","/bar-chart/BANKNIFTY_Strike_OI","/bar-chart/FINNIFTY_Strike_OI","/bar-chart/MIDCPNIFTY_Strike_OI"],
        title:"Inventory Visualization Charts: Illuminating the Options Landscape",
        demoVideo:[
            {
                name: "OI Viz Charts 1",
                src:"https://vimeo.com/802425925",
                yt_src: "https://youtu.be/419_jYo54cI"
            },
            {
                name: "OI Viz Charts 2",
                src:"https://vimeo.com/802425925",
                yt_src: "https://youtu.be/419_jYo54cI"
            },
            
        ]
    },{
        value:13,
        name:"Gamma Charts",
        id:"gamma_charts",
        path:["/bar-chart/NIFTY_Strike_Value","/bar-chart/BANKNIFTY_Strike_Value","/bar-chart/FINNIFTY_Strike_Value","/bar-chart/MIDCPNIFTY_Strike_Value"],
        title:"Gamma Visualization: The Art of Options Illumination",
        demoVideo:[
            {
                name: "Gamma Charts 1",
                src:"https://vimeo.com/802425925",
                yt_src: "https://youtu.be/G5n9__MxR24"
            },
            {
                name: "Gamma Charts 2",
                src:"https://vimeo.com/802425925",
                yt_src: "https://youtu.be/0TE9hzbJBQk"
            },
            
        ]
    },
    {
        value:14,
        name:"IV Curve Charts",
        id:"iv_curve_charts",
        path:["/bar-chart/NIFTY_Strike_IV","/bar-chart/BANKNIFTY_Strike_IV"],
        title:"Implied Volatility (IV) Curves: Decoding Market Pulse",
        demoVideo:[
            {
                name: "IV Curve Charts 1",
                src:"https://vimeo.com/802425925",
                yt_src: "https://youtu.be/TfyGzJYR2Zs"
            },
            {
                name: "IV Curve Charts 2",
                src:"https://vimeo.com/802425925",
                yt_src: "https://youtu.be/i986iS6MB_c"
            },
            
        ]
    },{
        value:15,
        name:"Options Snakes Line Charts",
        id:"options_snakes_line_charts",
        path:["/line-chart/NIFTY_Snakes","/line-chart/BANKNIFTY_Snakes","/line-chart/FINNIFTY_Snakes","/line-chart/MIDCPNIFTY_Snakes"],
        title:"Options Snakes Line Charts: Unraveling the Market's OI Dance",
        demoVideo:[
            {
                name: "Options Snakes Charts 1",
                src:"https://vimeo.com/802425925",
                yt_src: "https://youtu.be/419_jYo54cI"
            },
            {
                name: "Options Snakes Charts 2",
                src:"https://vimeo.com/802425925",
                yt_src: "https://youtu.be/TfyGzJYR2Zs"
            },
            
        ]
    },{
        value:16,
        name:"Options Volume Charts",
        id:"opt_vol_charts",
        path:["/line-chart/NF_Options_Vol_Charts","/line-chart/BN_Options_Vol_Charts","/line-chart/FN_Options_Vol_Charts","/line-chart/MN_Options_Vol_Charts"],
        title:"Decoding Volumes: Unveiling Market Pulse Through Moving Volumes Lines",
        demoVideo:[
            // {
            //     name: "OI Change Charts 1",
            //     src:"https://vimeo.com/802425925",
            //     yt_src: "https://youtu.be/Z5gSyz68jKw"
            // },
            // {
            //     name: "OI Change Charts 2",
            //     src:"https://vimeo.com/802425925",
            //     yt_src: "https://youtu.be/SnTTzUDiVIY"
            // },
            
        ]
    },
   

]   

export const INTRO_VIDIEOS = [
    {
      name: "The menu of the Charts",
      src:"https://vimeo.com/838217751",
      yt_src: "https://youtu.be/QSy9oUdZxy8"
    },
    {
        name: "Register for Vtrender™ Charts",
        src:"https://vimeo.com/838217723",
        yt_src: "https://youtu.be/EAhEGDhpYZg"
    },
    {
        name: "Market Profile Charts Section - Walkthrough",
        src:"https://vimeo.com/838217583",
        yt_src: "https://youtu.be/Ght8jNRidPo"
    },
    {
        name: "Additional Market Profile Info - Deep Dive",
        src:"https://vimeo.com/838217352",
        yt_src: "https://youtu.be/QSy9oUdZxy8"
    },
    {
        name: "Options Table - Part 1",
        src:"https://vimeo.com/838217621",
        yt_src: "https://youtu.be/EAhEGDhpYZg"
    },
    {
        name: "Options Table - Part 2",
        src:"https://vimeo.com/838217669",
        yt_src: "https://youtu.be/Ght8jNRidPo"
    },
    {
        name: "Greeks Table",
        src:"https://vimeo.com/838217442",
        yt_src: "https://youtu.be/QSy9oUdZxy8"
    },
    {
        name: "Index Table",
        src:"https://vimeo.com/838217528",
        yt_src: "https://youtu.be/EAhEGDhpYZg"
    },
    {
        name: "Spectrum Charts",
        src:"https://vimeo.com/838310937",
        yt_src: "https://youtu.be/Ght8jNRidPo"
    },
    {
        name: "OI Visualization Charts",
        src:"https://vimeo.com/839013191",
        yt_src: "https://youtu.be/Ght8jNRidPo"
    },
    {
        name: "Sensitivity",
        src:"https://vimeo.com/839014959",
        yt_src: "https://youtu.be/Ght8jNRidPo"
    },
    {
        name: "OI Change Charts",
        src:"https://vimeo.com/838317496",
        yt_src: "https://youtu.be/Ght8jNRidPo"
    }

  ] 

  export const OF_INTRO_VIDIEOS = [
    {
        name: "Introduction to Vtrender™'s Orderflow Charts",
        src:"https://vimeo.com/853735125",
        yt_src: "https://youtu.be/Ght8jNRidPo"
    },
    {
      name: "Market Liquidity in Orderflow",
      src:"https://vimeo.com/853796900",
      yt_src: "https://youtu.be/QSy9oUdZxy8"
    },
    {
        name: "COT and OI in Orderflow Charts",
        src:"https://vimeo.com/853805750",
        yt_src: "https://youtu.be/EAhEGDhpYZg"
    },
    {
        name: "Market Dynamics with RB, IB, RS and IS",
        src:"https://vimeo.com/853812666",
        yt_src: "https://youtu.be/Ght8jNRidPo"
    },
    {
        name: "Volume Clusters in Orderflow Charts",
        src:"https://vimeo.com/853750725",
        yt_src: "https://youtu.be/QSy9oUdZxy8"
    },
    {
        name: "Understanding Imbalances in Orderflow Charts",
        src:"https://vimeo.com/853743768",
        yt_src: "https://youtu.be/EAhEGDhpYZg"
    }
  ] 

export const OF_ZOOM_TYPE={
    SYMMETRIC:"symmetric",
    ASYMMETRIC:"asymmetric"
}

export const ROTATING_COT_COUNT=10;

export const ROTATING_COT_LIST=[5,10,15,20,30,40,50];

export const OF_BOTTOM_COL_LIST=["Volume","VPOC","VPOC Vol","COT","OI","dOI"];

export const SUBSCRIPTION_PLANS_PRICE_NEW={
    "monthly":{
        [TIERS.PREMIUM]:{
            "base":299,
            "base_gst":54,
            "stocks":699,
            "stocks_gst":126,
        },
       "expert":{
            "base":799,
            "base_gst":144,
            "stocks":999,
            "stocks_gst":180,
        },
        [TIERS.ELITE]:{
            "base":3999,
            "base_gst":720,
            "stocks":5999,
            "stocks_gst":1080,
        },
    },
    // Independence day offer - 10, 15, 30
    // "quarterly":{
    //     "premium":{
    //         "base":807,
    //         "base_gst":145,
    //         "base_actual":1059,
    //         "stocks":1887,
    //         "stocks_gst":340,
    //         "stocks_actual":2475,
    //     },
    //    "expert":{
    //         "base":2157,
    //         "base_gst":388,
    //         "base_actual":2859,
    //         "stocks":2697,
    //         "stocks_gst":485,
    //         "stocks_actual":3537
    //     },
    //     "elite":{
    //         "base":10797,
    //         "base_gst":1943,
    //         "base_actual":14157,
    //         "stocks":16197,
    //         "stocks_gst":2915,
    //         "stocks_actual":21237
    //     },
    // },
    // "half_yearly":{
    //     "premium":{
    //         "base":1525,
    //         "base_gst":274,
    //         "base_actual":2118,
    //         "stocks":3565,
    //         "stocks_gst":642,
    //         "stocks_actual":4950
    //     },
    //    "expert":{
    //         "base":4075,
    //         "base_gst":734,
    //         "base_actual":5718,
    //         "stocks":5095,
    //         "stocks_gst":917,
    //         "stocks_actual":7074
    //     },
    //     "elite":{
    //         "base":20395,
    //         "base_gst":3671,
    //         "base_actual":28314,
    //         "stocks":30595,
    //         "stocks_gst":5507,
    //         "stocks_actual":42474
    //     },

    // },
    // "annually":{
    //     "premium":{
    //         "base":2511,
    //         "base_gst":452,
    //         "base_actual":4236,
    //         "stocks":5871,
    //         "stocks_gst":1057,
    //         "stocks_actual":9900
    //     },
    //    "expert":{
    //         "base":6711,
    //         "base_gst":1208,
    //         "base_actual":11436,
    //         "stocks":8391,
    //         "stocks_gst":1510,
    //         "stocks_actual":14148
    //     },
    //     "elite":{
    //         "base":33591,
    //         "base_gst":6046,
    //         "base_actual":56628,
    //         "stocks":50391,
    //         "stocks_gst":9070,
    //         "stocks_actual":84948
    //     },
    // }

    // Diwali discounts - 5, 30, 30
    // "quarterly":{
    //     "premium":{
    //         "base":849,
    //         "base_gst":153,
    //         "base_actual":1059,
    //         "stocks":1989,
    //         "stocks_gst":358,
    //         "stocks_actual":2475,
    //     },
    //    "expert":{
    //         "base":2269,
    //         "base_gst":408,
    //         "base_actual":2859,
    //         "stocks":2839,
    //         "stocks_gst":511,
    //         "stocks_actual":3537
    //     },
    //     "elite":{
    //         "base":11389,
    //         "base_gst":2050,
    //         "base_actual":14157,
    //         "stocks":17089,
    //         "stocks_gst":3076,
    //         "stocks_actual":21237
    //     },
    // },
    // "half_yearly":{
    //     "premium":{
    //         "base":1255,
    //         "base_gst":226,
    //         "base_actual":2118,
    //         "stocks":2935,
    //         "stocks_gst":528,
    //         "stocks_actual":4950
    //     },
    //    "expert":{
    //         "base":4075,
    //         "base_gst":604,
    //         "base_actual":5718,
    //         "stocks":4195,
    //         "stocks_gst":755,
    //         "stocks_actual":7074
    //     },
    //     "elite":{
    //         "base":16795,
    //         "base_gst":3023,
    //         "base_actual":28314,
    //         "stocks":25195,
    //         "stocks_gst":4535,
    //         "stocks_actual":42474
    //     },
    // },
    // "annually":{
    //     "premium":{
    //         "base":2511,
    //         "base_gst":452,
    //         "base_actual":4236,
    //         "stocks":5871,
    //         "stocks_gst":1057,
    //         "stocks_actual":9900
    //     },
    //    "expert":{
    //         "base":6711,
    //         "base_gst":1208,
    //         "base_actual":11436,
    //         "stocks":8391,
    //         "stocks_gst":1510,
    //         "stocks_actual":14148
    //     },
    //     "elite":{
    //         "base":33591,
    //         "base_gst":6046,
    //         "base_actual":56628,
    //         "stocks":50391,
    //         "stocks_gst":9070,
    //         "stocks_actual":84948
    //     },
    // }

    // Normal discounts - 5, 10, 20
    "quarterly":{
        [TIERS.PREMIUM]:{
            "base":849,
            "base_gst":153,
            "base_actual":1059,
            "stocks":1989,
            "stocks_gst":358,
            "stocks_actual":2475,
        },
       "expert":{
            "base":2269,
            "base_gst":408,
            "base_actual":2859,
            "stocks":2839,
            "stocks_gst":511,
            "stocks_actual":3537
        },
        [TIERS.ELITE]:{
            "base":11389,
            "base_gst":2050,
            "base_actual":14157,
            "stocks":17089,
            "stocks_gst":3076,
            "stocks_actual":21237
        },
    },
    "half_yearly":{
        [TIERS.PREMIUM]:{
            "base":1609,
            "base_gst":290,
            "base_actual":2118,
            "stocks":3769,
            "stocks_gst":688,
            "stocks_actual":4950
        },
       "expert":{
            "base":4309,
            "base_gst":776,
            "base_actual":5718,
            "stocks":5389,
            "stocks_gst":970,
            "stocks_actual":7074
        },
        [TIERS.ELITE]:{
            "base":21589,
            "base_gst":3886,
            "base_actual":28314,
            "stocks":32389,
            "stocks_gst":5830,
            "stocks_actual":42474
        },
    },
    "annually":{
        [TIERS.PREMIUM]:{
            "base":2869,
            "base_gst":516,
            "base_actual":4236,
            "stocks":6709,
            "stocks_gst":1208,
            "stocks_actual":9900
        },
       "expert":{
            "base":7669,
            "base_gst":1380,
            "base_actual":11436,
            "stocks":9589,
            "stocks_gst":1726,
            "stocks_actual":14148
        },
        [TIERS.ELITE]:{
            "base":38389,
            "base_gst":6910,
            "base_actual":56628,
            "stocks":57589,
            "stocks_gst":10366,
            "stocks_actual":84948
        },
    }
}


export const SUBSCRIPTION_PLANS_NEW={
    PREMIUM_MONTHLY_1:"NEW_PREMIUM_MONTHLY_1",
    PREMIUM_MONTHLY_3:"NEW_PREMIUM_MONTHLY_3",
    PREMIUM_MONTHLY_6:"NEW_PREMIUM_MONTHLY_6",
    PREMIUM_MONTHLY_12:"NEW_PREMIUM_MONTHLY_12",
    PREMIUM_STOCKS_MONTHLY_1:"NEW_PREMIUM_STOCKS_MONTHLY_1",
    PREMIUM_STOCKS_MONTHLY_3:"NEW_PREMIUM_STOCKS_MONTHLY_3",
    PREMIUM_STOCKS_MONTHLY_6:"NEW_PREMIUM_STOCKS_MONTHLY_6",
    PREMIUM_STOCKS_MONTHLY_12:"NEW_PREMIUM_STOCKS_MONTHLY_12",
    PREMIUM_PLUS_MONTHLY_1:"NEW_PREMIUM_PLUS_MONTHLY_1",
    PREMIUM_PLUS_MONTHLY_3:"NEW_PREMIUM_PLUS_MONTHLY_3",
    PREMIUM_PLUS_MONTHLY_6:"NEW_PREMIUM_PLUS_MONTHLY_6",
    PREMIUM_PLUS_MONTHLY_12:"NEW_PREMIUM_PLUS_MONTHLY_12",
    PREMIUM_PLUS_STOCKS_MONTHLY_1:"NEW_PREMIUM_PLUS_STOCKS_MONTHLY_1",
    PREMIUM_PLUS_STOCKS_MONTHLY_3:"NEW_PREMIUM_PLUS_STOCKS_MONTHLY_3",
    PREMIUM_PLUS_STOCKS_MONTHLY_6:"NEW_PREMIUM_PLUS_STOCKS_MONTHLY_6",
    PREMIUM_PLUS_STOCKS_MONTHLY_12:"NEW_PREMIUM_PLUS_STOCKS_MONTHLY_12",
    PREMIUM_PLUS_ORDERFLOW_INDEX_MONTHLY_1:"NEW_PREMIUM_PLUS_ORDERFLOW_INDEX_MONTHLY_1",
    PREMIUM_PLUS_ORDERFLOW_INDEX_MONTHLY_3:"NEW_PREMIUM_PLUS_ORDERFLOW_INDEX_MONTHLY_3",
    PREMIUM_PLUS_ORDERFLOW_INDEX_MONTHLY_6:"NEW_PREMIUM_PLUS_ORDERFLOW_INDEX_MONTHLY_6",
    PREMIUM_PLUS_ORDERFLOW_INDEX_MONTHLY_12:"NEW_PREMIUM_PLUS_ORDERFLOW_INDEX_MONTHLY_12",
    PREMIUM_PLUS_ORDERFLOW_INDEX_STOCKS_MONTHLY_1:"NEW_PREMIUM_PLUS_ORDERFLOW_INDEX_STOCKS_MONTHLY_1",
    PREMIUM_PLUS_ORDERFLOW_INDEX_STOCKS_MONTHLY_3:"NEW_PREMIUM_PLUS_ORDERFLOW_INDEX_STOCKS_MONTHLY_3",
    PREMIUM_PLUS_ORDERFLOW_INDEX_STOCKS_MONTHLY_6:"NEW_PREMIUM_PLUS_ORDERFLOW_INDEX_STOCKS_MONTHLY_6",
    PREMIUM_PLUS_ORDERFLOW_INDEX_STOCKS_MONTHLY_12:"NEW_PREMIUM_PLUS_ORDERFLOW_INDEX_STOCKS_MONTHLY_12",
}

export const SUBSCRIPTION_PLANS_NSE={
    PREMIUM_MONTHLY_1:"NSE_PREMIUM_MONTHLY_1",
    PREMIUM_MONTHLY_3:"NSE_PREMIUM_MONTHLY_3",
    PREMIUM_MONTHLY_6:"NSE_PREMIUM_MONTHLY_6",
    PREMIUM_MONTHLY_12:"NSE_PREMIUM_MONTHLY_12",
    PREMIUM_STOCKS_MONTHLY_1:"NSE_PREMIUM_STOCKS_MONTHLY_1",
    PREMIUM_STOCKS_MONTHLY_3:"NSE_PREMIUM_STOCKS_MONTHLY_3",
    PREMIUM_STOCKS_MONTHLY_6:"NSE_PREMIUM_STOCKS_MONTHLY_6",
    PREMIUM_STOCKS_MONTHLY_12:"NSE_PREMIUM_STOCKS_MONTHLY_12",
    PREMIUM_PLUS_MONTHLY_1:"NSE_PREMIUM_PLUS_MONTHLY_1",
    PREMIUM_PLUS_MONTHLY_3:"NSE_PREMIUM_PLUS_MONTHLY_3",
    PREMIUM_PLUS_MONTHLY_6:"NSE_PREMIUM_PLUS_MONTHLY_6",
    PREMIUM_PLUS_MONTHLY_12:"NSE_PREMIUM_PLUS_MONTHLY_12",
    PREMIUM_PLUS_STOCKS_MONTHLY_1:"NSE_PREMIUM_PLUS_STOCKS_MONTHLY_1",
    PREMIUM_PLUS_STOCKS_MONTHLY_3:"NSE_PREMIUM_PLUS_STOCKS_MONTHLY_3",
    PREMIUM_PLUS_STOCKS_MONTHLY_6:"NSE_PREMIUM_PLUS_STOCKS_MONTHLY_6",
    PREMIUM_PLUS_STOCKS_MONTHLY_12:"NSE_PREMIUM_PLUS_STOCKS_MONTHLY_12",
    PREMIUM_PLUS_ORDERFLOW_INDEX_MONTHLY_1:"NSE_PREMIUM_PLUS_ORDERFLOW_INDEX_MONTHLY_1",
    PREMIUM_PLUS_ORDERFLOW_INDEX_MONTHLY_3:"NSE_PREMIUM_PLUS_ORDERFLOW_INDEX_MONTHLY_3",
    PREMIUM_PLUS_ORDERFLOW_INDEX_MONTHLY_6:"NSE_PREMIUM_PLUS_ORDERFLOW_INDEX_MONTHLY_6",
    PREMIUM_PLUS_ORDERFLOW_INDEX_MONTHLY_12:"NSE_PREMIUM_PLUS_ORDERFLOW_INDEX_MONTHLY_12",
    PREMIUM_PLUS_ORDERFLOW_INDEX_STOCKS_MONTHLY_1:"NSE_PREMIUM_PLUS_ORDERFLOW_INDEX_STOCKS_MONTHLY_1",
    PREMIUM_PLUS_ORDERFLOW_INDEX_STOCKS_MONTHLY_3:"NSE_PREMIUM_PLUS_ORDERFLOW_INDEX_STOCKS_MONTHLY_3",
    PREMIUM_PLUS_ORDERFLOW_INDEX_STOCKS_MONTHLY_6:"NSE_PREMIUM_PLUS_ORDERFLOW_INDEX_STOCKS_MONTHLY_6",
    PREMIUM_PLUS_ORDERFLOW_INDEX_STOCKS_MONTHLY_12:"NSE_PREMIUM_PLUS_ORDERFLOW_INDEX_STOCKS_MONTHLY_12",
    PREMIUM_PLUS_ORDERFLOW_INDEX_MONTHLY_1_INTERNATIONAL:"NSE_PREMIUM_PLUS_ORDERFLOW_INDEX_INTERNATIONAL_MONTHLY_1",
    PREMIUM_PLUS_ORDERFLOW_INDEX_MONTHLY_3_INTERNATIONAL:"NSE_PREMIUM_PLUS_ORDERFLOW_INDEX_INTERNATIONAL_MONTHLY_3",
    PREMIUM_PLUS_ORDERFLOW_INDEX_MONTHLY_6_INTERNATIONAL:"NSE_PREMIUM_PLUS_ORDERFLOW_INDEX_INTERNATIONAL_MONTHLY_6",
    PREMIUM_PLUS_ORDERFLOW_INDEX_MONTHLY_12_INTERNATIONAL:"NSE_PREMIUM_PLUS_ORDERFLOW_INDEX_INTERNATIONAL_MONTHLY_12",
    PREMIUM_PLUS_ORDERFLOW_INDEX_STOCKS_MONTHLY_1_INTERNATIONAL:"NSE_PREMIUM_PLUS_ORDERFLOW_INDEX_STOCKS_INTERNATIONAL_MONTHLY_1",
    PREMIUM_PLUS_ORDERFLOW_INDEX_STOCKS_MONTHLY_3_INTERNATIONAL:"NSE_PREMIUM_PLUS_ORDERFLOW_INDEX_STOCKS_INTERNATIONAL_MONTHLY_3",
    PREMIUM_PLUS_ORDERFLOW_INDEX_STOCKS_MONTHLY_6_INTERNATIONAL:"NSE_PREMIUM_PLUS_ORDERFLOW_INDEX_STOCKS_INTERNATIONAL_MONTHLY_6",
    PREMIUM_PLUS_ORDERFLOW_INDEX_STOCKS_MONTHLY_12_INTERNATIONAL:"NSE_PREMIUM_PLUS_ORDERFLOW_INDEX_STOCKS_INTERNATIONAL_MONTHLY_12",
}

export const SUBSCRIPTION_PLANS_NSE_NEW={
    PROFESSIONAL_MONTHLY_1:"NSE_PREMIUM_PLUS_INDEX_MONTHLY_1",
    PROFESSIONAL_MONTHLY_3:"NSE_PREMIUM_PLUS_INDEX_MONTHLY_3",
    PROFESSIONAL_MONTHLY_6:"NSE_PREMIUM_PLUS_INDEX_MONTHLY_6",
    PROFESSIONAL_MONTHLY_12:"NSE_PREMIUM_PLUS_INDEX_MONTHLY_12",
    PROFESSIONAL_STOCKS_MONTHLY_1:"NSE_PREMIUM_PLUS_INDEX_STOCKS_MONTHLY_1",
    PROFESSIONAL_STOCKS_MONTHLY_3:"NSE_PREMIUM_PLUS_INDEX_STOCKS_MONTHLY_3",
    PROFESSIONAL_STOCKS_MONTHLY_6:"NSE_PREMIUM_PLUS_INDEX_STOCKS_MONTHLY_6",
    PROFESSIONAL_STOCKS_MONTHLY_12:"NSE_PREMIUM_PLUS_INDEX_STOCKS_MONTHLY_12",
    PROFESSIONAL_INDEX_MONTHLY_1_INTERNATIONAL:"NSE_PREMIUM_PLUS_INDEX_INTERNATIONAL_MONTHLY_1",
    PROFESSIONAL_INDEX_MONTHLY_3_INTERNATIONAL:"NSE_PREMIUM_PLUS_INDEX_INTERNATIONAL_MONTHLY_3",
    PROFESSIONAL_INDEX_MONTHLY_6_INTERNATIONAL:"NSE_PREMIUM_PLUS_INDEX_INTERNATIONAL_MONTHLY_6",
    PROFESSIONAL_INDEX_MONTHLY_12_INTERNATIONAL:"NSE_PREMIUM_PLUS_INDEX_INTERNATIONAL_MONTHLY_12",
    PROFESSIONAL_INDEX_STOCKS_MONTHLY_1_INTERNATIONAL:"NSE_PREMIUM_PLUS_INDEX_STOCKS_INTERNATIONAL_MONTHLY_1",
    PROFESSIONAL_INDEX_STOCKS_MONTHLY_3_INTERNATIONAL:"NSE_PREMIUM_PLUS_INDEX_STOCKS_INTERNATIONAL_MONTHLY_3",
    PROFESSIONAL_INDEX_STOCKS_MONTHLY_6_INTERNATIONAL:"NSE_PREMIUM_PLUS_INDEX_STOCKS_INTERNATIONAL_MONTHLY_6",
    PROFESSIONAL_INDEX_STOCKS_MONTHLY_12_INTERNATIONAL:"NSE_PREMIUM_PLUS_INDEX_STOCKS_INTERNATIONAL_MONTHLY_12",

    PROFESSIONAL_NSE_INDEX_BSE_INDEX_MONTHLY_1: "BSE_NSE_PREMIUM_PLUS_INDEX_MONTHLY_1",
    PROFESSIONAL_NSE_INDEX_BSE_INDEX_MONTHLY_3: "BSE_NSE_PREMIUM_PLUS_INDEX_MONTHLY_3",
    PROFESSIONAL_NSE_INDEX_BSE_INDEX_MONTHLY_6: "BSE_NSE_PREMIUM_PLUS_INDEX_MONTHLY_6",
    PROFESSIONAL_NSE_INDEX_BSE_INDEX_MONTHLY_12: "BSE_NSE_PREMIUM_PLUS_INDEX_MONTHLY_12",

    PROFESSIONAL_NSE_STOCKS_BSE_INDEX_MONTHLY_1: "BSE_NSE_PREMIUM_PLUS_INDEX_STOCKS_MONTHLY_1",
    PROFESSIONAL_NSE_STOCKS_BSE_INDEX_MONTHLY_3: "BSE_NSE_PREMIUM_PLUS_INDEX_STOCKS_MONTHLY_3",
    PROFESSIONAL_NSE_STOCKS_BSE_INDEX_MONTHLY_6: "BSE_NSE_PREMIUM_PLUS_INDEX_STOCKS_MONTHLY_6",
    PROFESSIONAL_NSE_STOCKS_BSE_INDEX_MONTHLY_12: "BSE_NSE_PREMIUM_PLUS_INDEX_STOCKS_MONTHLY_12",

    PROFESSIONAL_BSE_INDEX_MONTHLY_1: "BSE_PREMIUM_PLUS_INDEX_MONTHLY_1",

    ELITE_INDEX_MONTHLY_1:"NSE_PREMIUM_PLUS_ORDERFLOW_INDEX_MONTHLY_1",
    ELITE_INDEX_MONTHLY_3:"NSE_PREMIUM_PLUS_ORDERFLOW_INDEX_MONTHLY_3",
    ELITE_INDEX_MONTHLY_6:"NSE_PREMIUM_PLUS_ORDERFLOW_INDEX_MONTHLY_6",
    ELITE_INDEX_MONTHLY_12:"NSE_PREMIUM_PLUS_ORDERFLOW_INDEX_MONTHLY_12",
    ELITE_INDEX_STOCKS_MONTHLY_1:"NSE_PREMIUM_PLUS_ORDERFLOW_INDEX_STOCKS_MONTHLY_1",
    ELITE_INDEX_STOCKS_MONTHLY_3:"NSE_PREMIUM_PLUS_ORDERFLOW_INDEX_STOCKS_MONTHLY_3",
    ELITE_INDEX_STOCKS_MONTHLY_6:"NSE_PREMIUM_PLUS_ORDERFLOW_INDEX_STOCKS_MONTHLY_6",
    ELITE_INDEX_STOCKS_MONTHLY_12:"NSE_PREMIUM_PLUS_ORDERFLOW_INDEX_STOCKS_MONTHLY_12",
    ELITE_INDEX_MONTHLY_1_INTERNATIONAL:"NSE_PREMIUM_PLUS_ORDERFLOW_INDEX_INTERNATIONAL_MONTHLY_1",
    ELITE_INDEX_MONTHLY_3_INTERNATIONAL:"NSE_PREMIUM_PLUS_ORDERFLOW_INDEX_INTERNATIONAL_MONTHLY_3",
    ELITE_INDEX_MONTHLY_6_INTERNATIONAL:"NSE_PREMIUM_PLUS_ORDERFLOW_INDEX_INTERNATIONAL_MONTHLY_6",
    ELITE_INDEX_MONTHLY_12_INTERNATIONAL:"NSE_PREMIUM_PLUS_ORDERFLOW_INDEX_INTERNATIONAL_MONTHLY_12",
    ELITE_INDEX_STOCKS_MONTHLY_1_INTERNATIONAL:"NSE_PREMIUM_PLUS_ORDERFLOW_INDEX_STOCKS_INTERNATIONAL_MONTHLY_1",
    ELITE_INDEX_STOCKS_MONTHLY_3_INTERNATIONAL:"NSE_PREMIUM_PLUS_ORDERFLOW_INDEX_STOCKS_INTERNATIONAL_MONTHLY_3",
    ELITE_INDEX_STOCKS_MONTHLY_6_INTERNATIONAL:"NSE_PREMIUM_PLUS_ORDERFLOW_INDEX_STOCKS_INTERNATIONAL_MONTHLY_6",
    ELITE_INDEX_STOCKS_MONTHLY_12_INTERNATIONAL:"NSE_PREMIUM_PLUS_ORDERFLOW_INDEX_STOCKS_INTERNATIONAL_MONTHLY_12",

    ELITE_NSE_INDEX_BSE_INDEX_MONTHLY_1:"BSE_NSE_PREMIUM_PLUS_ORDERFLOW_INDEX_MONTHLY_1",
    ELITE_NSE_INDEX_BSE_INDEX_MONTHLY_3:"BSE_NSE_PREMIUM_PLUS_ORDERFLOW_INDEX_MONTHLY_3",
    ELITE_NSE_INDEX_BSE_INDEX_MONTHLY_6:"BSE_NSE_PREMIUM_PLUS_ORDERFLOW_INDEX_MONTHLY_6",
    ELITE_NSE_INDEX_BSE_INDEX_MONTHLY_12:"BSE_NSE_PREMIUM_PLUS_ORDERFLOW_INDEX_MONTHLY_12",


    ELITE_NSE_STOCKS_BSE_INDEX_MONTHLY_1: "BSE_NSE_PREMIUM_PLUS_ORDERFLOW_INDEX_STOCKS_MONTHLY_1",
    ELITE_NSE_STOCKS_BSE_INDEX_MONTHLY_3: "BSE_NSE_PREMIUM_PLUS_ORDERFLOW_INDEX_STOCKS_MONTHLY_3",
    ELITE_NSE_STOCKS_BSE_INDEX_MONTHLY_6: "BSE_NSE_PREMIUM_PLUS_ORDERFLOW_INDEX_STOCKS_MONTHLY_6",
    ELITE_NSE_STOCKS_BSE_INDEX_MONTHLY_12: "BSE_NSE_PREMIUM_PLUS_ORDERFLOW_INDEX_STOCKS_MONTHLY_12",

    ELITE_BSE_INDEX_MONTHLY_1: "BSE_PREMIUM_PLUS_ORDERFLOW_INDEX_MONTHLY_1"

}


export const EXCHANGE_MODES = {
    NSE: "nse",
    BSE_TOP_UP: "bse_top_up",
    NSE_BSE: "nse_bse"
}

export const SUBSCRIPTION_PLANS_PRICE_NSE_DATA = {
  monthly: {
    [EXCHANGE_MODES.NSE]: {
      professional: {
        base: 2499,
        base_gst: 450,
        base_i: 2999,
        base_gst_i: 540,
        stocks: 3499,
        stocks_gst: 630,
        stocks_i: 3999,
        stocks_gst_i: 720,
      },
      [TIERS.ELITE]: {
        base: 4999,
        base_gst: 900,
        base_i: 5499,
        base_gst_i: 990,
        stocks: 7999,
        stocks_gst: 1440,
        stocks_i: 8499,
        stocks_gst_i: 1530,
      },
    },
    [EXCHANGE_MODES.NSE_BSE]: {
      professional: {
        base: 3699,
        base_gst: 666,
        stocks: 4699,
        stocks_gst: 846,
      },
      [TIERS.ELITE]: {
        base: 6999,
        base_gst: 1260,
        stocks: 9999,
        stocks_gst: 1800,
      },
    },
  },

  quarterly: {
    [EXCHANGE_MODES.NSE]: {
      professional: {
        base: 7122,
        base_gst: 1282,
        base_actual: 8846,
        base_i: 8547,
        base_gst_i: 1538,
        base_actual_i: 10616,
        stocks: 9972,
        stocks_gst: 1795,
        stocks_actual: 12386,
        stocks_i: 11397,
        stocks_gst_i: 2051,
        stocks_actual_i: 14156,
      },
      [TIERS.ELITE]: {
        base: 14247,
        base_gst: 2564,
        base_actual: 17696,
        base_i: 15672,
        base_gst_i: 2821,
        base_actual_i: 19466,
        stocks: 22797,
        stocks_gst: 4103,
        stocks_actual: 28316,
        stocks_i: 24222,
        stocks_gst_i: 4360,
        stocks_actual_i: 30086,
      },
    },
    [EXCHANGE_MODES.NSE_BSE]: {
      professional: {
        base: 10542,
        base_gst: 1898,
        base_actual: 13094,
        stocks: 13392,
        stocks_gst: 2411,
        stocks_actual: 16634,
      },
      [TIERS.ELITE]: {
        base: 19947,
        base_gst: 3590,
        base_actual: 24776,
        stocks: 28497,
        stocks_gst: 5129,
        stocks_actual: 35396,
      },
    },
  },

  half_yearly: {
    [EXCHANGE_MODES.NSE]: {
      professional: {
        base: 13495,
        base_gst: 2429,
        base_actual: 17693,
        base_i: 16195,
        base_gst_i: 2915,
        base_actual_i: 21233,
        stocks: 18895,
        stocks_gst: 3401,
        stocks_actual: 24773,
        stocks_i: 21595,
        stocks_gst_i: 3887,
        stocks_actual_i: 28313,
      },
      [TIERS.ELITE]: {
        base: 26995,
        base_gst: 4859,
        base_actual: 35393,
        base_i: 29695,
        base_gst_i: 5345,
        base_actual_i: 38933,
        stocks: 43195,
        stocks_gst: 7775,
        stocks_actual: 56633,
        stocks_i: 45895,
        stocks_gst_i: 8261,
        stocks_actual_i: 60173,
      },
    },
    [EXCHANGE_MODES.NSE_BSE]: {
      professional: {
        base: 19975,
        base_gst: 3596,
        base_actual: 26189,
        stocks: 25375,
        stocks_gst: 4568,
        stocks_actual: 33269,
      },
      [TIERS.ELITE]: {
        base: 37795,
        base_gst: 6803,
        base_actual: 49553,
        stocks: 53995,
        stocks_gst: 9719,
        stocks_actual: 70793,
      },
    },
  },

  annually: {
    [EXCHANGE_MODES.NSE]: {
      professional: {
        base: 25490,
        base_gst: 4588,
        base_actual: 35386,
        base_i: 30590,
        base_gst_i: 5506,
        base_actual_i: 42466,
        stocks: 35690,
        stocks_gst: 6424,
        stocks_actual: 49546,
        stocks_i: 40790,
        stocks_gst_i: 7342,
        stocks_actual_i: 56626,
      },
      [TIERS.ELITE]: {
        base: 50990,
        base_gst: 9178,
        base_actual: 70786,
        base_i: 56090,
        base_gst_i: 10096,
        base_actual_i: 77866,
        stocks: 81590,
        stocks_gst: 14686,
        stocks_actual: 113266,
        stocks_i: 86690,
        stocks_gst_i: 15604,
        stocks_actual_i: 120346,
      },
    },
    [EXCHANGE_MODES.NSE_BSE]: {
      professional: {
        base: 37730,
        base_gst: 6791,
        base_actual: 52378,
        stocks: 47930,
        stocks_gst: 8627,
        stocks_actual: 66538,
      },
      [TIERS.ELITE]: {
        base: 71390,
        base_gst: 12850,
        base_actual: 99106,
        stocks: 101990,
        stocks_gst: 18358,
        stocks_actual: 141586,
      },
    },
  },
};



export const SUBSCRIPTION_PLAN_TYPE={
    PROFESSIONAL:"PROFESSIONAL",
    ELITE:"ELITE"
}


export const DISCOUNT_CONFIG = {
  percentage: 35,
  code: "DEMO35",
  label: '35% OFF'
};

export const TRADING_HOURS={
    START_HOUR:9,       //9am
    END_HOUR:15,        //15pm
    START_MINUTE:15,    //15mins(9:15)
    END_MINUTE:30       //30min(15:30)   
}

export const TRADING_TIME_START_LIMIT="11:00"   //to load the prev profile if time is less than this
export const TRADING_TIME_END_LIMIT="14:00"     //to load the next profile if time is more than this

//Keyboar zoom pan related constants:
export const OF_KEYBOARD_ZOOM_PAN={
    PAN_STEP:20,
    ACCELERATION_STEP:0.2,
    MAX_ACCLERATION:5
}

export const MP_KEYBOARD_ZOOM_PAN={
    PAN_STEP:20,
    ACCELERATION_STEP:0.2,
    MAX_ACCLERATION:5
}

export const CANDLE_KEYBOARD_ZOOM_PAN={
    PAN_STEP:20,
    ACCELERATION_STEP:0.2,
    MAX_ACCLERATION:5
}

export const OUTLINE_HOVER = "1px solid yellow"; // Define a constant
export const OUTLINE_DEFAULT = "none"; // Define another constant for default
export const YSCALE_OUTLINE_COLOR="yellow"; //Note: keep the outline width and color in sync
export const YSCALE_OUTLINE_WIDTH=1;
export const YSCALE_OUTLINE_WIDTH_BOTTOM=2;

export const DEMO_POPUP_TYPES = {
  NEW_USER: 'new_user',
  DEMO_ACTIVE: 'demo_active',
  DEMO_COMPLETED: 'demo_completed'
};

export const DEMO_POPUP_STATUS = {
  DEMO_NOT_STARTED: 'N',
  DEMO_STARTED: 'D',
  DEMO_FINISHED: 'F'
};

export const KEYBOARD_SHORTCUT={
    RECENTER:"r"
}

//Replay speed related constants
    export const REPLAY_SPEED={
        DEFAULT:1000,
        FAST:500,
        FASTER:250,
        FASTEST:100
    }
    export const REPLAY_SPEED_OPTIONS = [
    
        { label: "Normal load frequency", value: REPLAY_SPEED.DEFAULT,name:"Normal" },
        { label: "Fast load frequency", value: REPLAY_SPEED.FAST,name:"Fast" },
        { label: "Faster load frequency", value: REPLAY_SPEED.FASTER,name:"Faster" },
        { label: "Fastest load frequency", value: REPLAY_SPEED.FASTEST,name:"Fastest" },
    
    ];

//Replay bucket size related constants
  export const REPLAY_BUCKET_SIZE={
    DEFAULT:10,
    // SIZE_0_5X:20,
    SIZE_2X:5,
    SIZE_5X:2,
    SIZE_10X:1
    }  
  export const REPLAY_BUCKET_OPTIONS = [
    // { label: "0.5x (20 buckets)", value: REPLAY_BUCKET_SIZE.SIZE_0_5X,name:"0.5x" },
    { label: "1x replay speed", value: REPLAY_BUCKET_SIZE.DEFAULT,name:"1x" },
    { label: "2x replay speed", value: REPLAY_BUCKET_SIZE.SIZE_2X,name:"2x" },
    { label: "5x replay speed", value: REPLAY_BUCKET_SIZE.SIZE_5X,name:"5x" },
    { label: "10x replay speed", value: REPLAY_BUCKET_SIZE.SIZE_10X,name:"10x" },
  ];

  export const DRAWING_OBJECT_TYPE={
    LINE:"LINE",
    HORIZONTAL_LINE:"horizontalLine",
    HORIZONTAL_RAY:"horizontalRay",
    PARALLEL_CHANNEL:"parallelChannel",
    HORIZONTAL_CHANNEL:"horizontalChannel"
  }

  export const DRAWING_OBJECT_PROPS={
    LINE:{width:2,color:"#F7F74F",style:"solid"},
    HORIZONTAL_LINE:{width:2,color:"#F7F74F",style:"solid"},
    PARALLEL_CHANNEL:{width:2,color:"#F7F74F",style:"solid"}
  }

  export const DRAWING_TOOL_WIDTH_LIST=[1, 2, 3, 4];

  export const GLOBAL_BOOKMARK_RESULTS={
    SUCCESS:'success',
    NOT_FOUND:"not_found",
    UNAUTHORIZED:"unauthorized"
  }

  export const DRAWING_CONTEXT_MENU_WIDTH=240;

  export const firebaseConfigServer = {
    apiKey: "AIzaSyBEXyI-1l0Cgmk3LGVzjgB2cwKgTK0S0ok",
    authDomain: "vtcharts-bb17d.firebaseapp.com",
    projectId: "vtcharts-bb17d",
    storageBucket: "vtcharts-bb17d.firebasestorage.app",
    messagingSenderId: "364001910195",
    appId: "1:364001910195:web:e874a243fbf616e59cffc6",
    measurementId: "G-7K34N2TR15"
  };

  export const vapKeyServer="BHW6w--hQimO0BG82UmPzC_468p3TBuXiTIm2AvWFOlxxsZ1Vj5rfWusn1rzWyoLHsBkFYR9fj5xpGXPsDehhho";

  export const PAYMENT_METHOD_CCAVENUE = "CCAVENUE"
  export const PAYMENT_METHOD_RAZORPAY = "RAZORPAY"

  export const VMR_PLANS_MAP = {
        "VMR Monthly": "VMR_PREMIUM_PLUS_ORDERFLOW_INDEX_STOCKS_MONTHLY_1",
        "VMR Quarterly": "VMR_PREMIUM_PLUS_ORDERFLOW_INDEX_STOCKS_MONTHLY_3",
        "VMR Yearly": "VMR_PREMIUM_PLUS_ORDERFLOW_INDEX_STOCKS_MONTHLY_12",
    }

export const WATCHLIST_CHARTS = {
    ORDERFLOW: "ORDERFLOW",
    LINECHART: "LINECHART",
    BARCHART: "BARCHART",
    MARKETPROFILE: "MARKETPROFILE",
};

// Index data structure
export const MANUAL_SECTIONS = [
  {
    title: 'Start Here',
    subs: [
      {
        title: '<h2>Welcome to Vtrender<sup>™</sup> Charts</h2>',
        description: `
        <p>Your all-in-one space to read market structure, real-time intent, and trader positioning using <strong>MarketProfile</strong>, <strong>Orderflow</strong>, and <strong>Options data</strong>. 
        This platform is designed to show you what's <em>really</em> happening behind every price move.</p>
        \n<p>This isn't about blind charting or hunting patterns that stopped working years ago.</p>
        \n<p>This is about reading the market's <em>structure</em>, its <em>real-time intent</em>, and <em>trader positioning</em> — all in one integrated, dynamic view.</p>
        \n<p>We created this manual to guide you clearly, visually, and confidently. And for your trading to improve.</p>`
      },
      {
        title: '<h2>Why MarketProfile + Orderflow + Options Together?</h2>',
        description: `<p>
            Most platforms show you candles. We show you <em>what’s behind the candles</em>.
          </p>

          <p>Here’s how the trio works together:</p>

          <ul>
            <li>
              <strong>MarketProfile</strong> reveals how the market is structured — who’s dominating
              value, what price zones are getting accepted, and where rejection is likely.

              <img src="${marketProfileImg}" alt="Market Profile" />
            </li>
            <li>
              <strong>Orderflow</strong> exposes real-time supply and demand — buying/selling
              imbalances, initiative trades, absorption, and traps, bar-by-bar.

              <img src="${orderflowImg}" alt="Orderflow" />
            </li>
            <li>
              <strong>Options Data</strong> shows you where traders are betting, hedging, or
              defending positions — from straddle setups to gamma builds and writer
              activity.

              <img src="${optTableImg}" alt="Options Table" />
            </li>
          </ul>

          <p>
            On their own, each tells a part of the story.<br>
            Together, they reveal the full market <em>intent and opportunity.</em>
          </p>
        `
      },

      {
        title: `<h2>How to Use This Manual</h2>`,
                description: `<p>This manual is your personal flight manual for Vtrender<sup>™</sup> Charts — structured
            so you can explore in three ways:</p>

          <ol>
            <li>
              <strong>New to this?</strong><br>
              Start with the <strong>5-Min Quickstarts</strong>. These guides are like a friend
              sitting next to you, showing exactly what to click and what it means.
            </li>
            <li>
              <strong>Been here before?</strong><br>
              Go to <strong>Explore the Tools</strong> to dive deeper into each chart category —
              MarketProfile, Orderflow, Options, and more.
            </li>
            <li>
              <strong>Trading actively?</strong><br>
              Head to <strong>Advanced Tools & Custom Views</strong> for the full arsenal —
              like Speedo, Bookmarks, and Gamma overlays.
            </li>
          </ol>

          <p>
            ✨ You can also use the <strong>search bar</strong> (coming soon) or scroll through
            each section using the collapsible menu on the left.<br>
            We’ve also added visuals, glossary terms, and pro tips throughout —
            because learning should feel empowering, not overwhelming.
          </p>`
      },
      {
        title: `<h2>First-Time User Setup Checklist</h2>`,
        description: `<p>Just landed? Here’s your no-fuss setup:</p>

          <ul>
            <li>Log in with your Vtrender<sup>™</sup> ID</li>
            <li>Choose an instrument (e.g., NIFTY Futures) from the dropdown</li>
            <li>Load a MarketProfile chart or an Orderflow chart</li>
            <li>Split screen: Add Orderflow on the right</li>
            <li>Click ‘Options Table’ → Select NTM strikes</li>
            <li>Locate VWAP, POC, and IB range on the chart</li>
            <li>Try the ‘Date Picker’ or ‘Replay’ for deeper analysis</li>
            <li>Bookmark your layout for tomorrow</li>
          </ul>
        
          <p>
            You’re now up and running with the core of Vtrender<sup>™</sup>’s ecosystem.<br>
            Each section in the manual will build on this foundation.
          </p>`
        
      },
      
    ],
  },
  {
    title: 'How to Use Charts',
    subs: [
      {
        title: `<h2> Step 1: Navigating the Dashboard</h2>`,
        description: `<p>
                    Start from the <strong>Hamburger menu</strong> at the top left.
                  </p>

                  <p>
                    A full menu opens on the left and you will see all the options here.
                    Start with <strong>Orderflow</strong>, <strong>MarketProfile</strong>, and <strong>Smart Candlesticks<sup>™</sup></strong>.
                  </p>

                  <p>
                    There is lots more below. Use the <strong>dropdown menu</strong> to open up more menu options.
                  </p>`
      },
      {
        title: `<h2>Step 2: Loading a Chart Layout</h2>`,
        description: `<p>
                      Start from the <strong>Hamburger menu</strong> at the top left.
                    </p>

                    <p>
                      A full menu opens on the left and you will see all the options here.
                      Start with <strong>Orderflow</strong>, <strong>MarketProfile</strong>, and <strong>Smart Candlesticks<sup>™</sup></strong>.
                    </p>

                    <p>
                      There is lots more below. Use the <strong>dropdown menu</strong> to open up more menu options.
                    </p>
                    `
      },
      {
        title: `<h2>Step 3: Using Zoom and Bookmarks & Saved Views</h2>`,
        description: `<p>
                      You can use the <strong>mouse scroll</strong> in Windows to zoom in/out,
                      or use the <strong>arrow keys</strong> (↑ / ↓) to scroll vertically through the chart.
                    </p>

                    <p>
                      <em>(iOS settings for zooming and navigation will be added here.)</em>
                    </p>

                    <p>
                      If the chart goes out of scale, use the <strong>Reset</strong> button located either:
                      <ul>
                        <li>Floating at the bottom center of the screen</li>
                        <li>Or at the extreme bottom-right corner of the chart</li>
                      </ul>
                    </p>
                    `
      },
      {
        title: `<h2>Step 4: Playback & Replay (Optional Tools)</h2>`,
        description: `<p>
                      Use the <strong>Date Picker</strong> at the top center to quickly go to any date in the past
                      and see how the market behaved on that day.
                    </p>

                    <p>
                      Use <strong>Replay Mode</strong> to review past market sessions at your own pace.
                      Pause, rewind, and rewatch how price moved, how Orderflow shifted, or how a breakout formed.
                    </p>

                    <p>
                      Ideal for <em>refining strategy</em>, <em>spotting missed signals</em>, or
                      <em>mentoring new traders</em>.
                    </p>
                    `
      },
    ],
  },



  {
    title: '5 Min Quick Start',
    subs: [
      {
        title: `<h2>Your First Orderflow Chart</h2>`,
        description: ` <p>Want to see who’s really buying or selling? Let’s open your first Orderflow chart.</p>

                      <ol>
                        <li>From the left menu, click <strong>Orderflow Charts</strong></li>
                        <li>Select an instrument (try <strong>NIFTY Futures</strong>)</li>
                        <li>Watch for colored blocks inside the candle – that’s live trade data</li>
                        <li>Hover to inspect volume, buyers, and sellers</li>
                      </ol>

                      <div class="tip">
                      💡 <strong>Look for purple bars</strong> — those are Initiative Sellers stepping in.<br>
                      💡 <strong>Green bars</strong> indicate Initiative Buyers.
                      </div>

                      <img src="${orderflowImg}" alt="Orderflow Charts" />

                    `
      },
      {
        title: `<h2>Reading a MarketProfile Chart</h2>`,
        description: ` <p>Let’s read the market’s structure — where it’s balanced, where it’s pushing.</p>

                      <ol>
                        <li>Click <strong>MarketProfile Charts</strong> from the menu</li>
                        <li>Choose <strong>BANKNIFTY Futures</strong> (or any active symbol)</li>
                        <li>Focus on:</li>
                      </ol>

                      <ul>
                        <li><strong>POC (Yellow Line)</strong> — the price with highest activity</li>
                        <li><strong>Value Area (Blue Blocks)</strong> — where 70% of trading happened</li>
                        <li><strong>IB Range</strong> — early market direction</li>
                      </ul>
                      <div class="tip">
                      💡 <strong>If price is above VAH and holding, buyers may be in control.</strong>
                      </div>

                      <img src="${marketProfileImg}" alt="Market Profile Charts" />
                    `
      },

     {
      title: `<h2>See Option Writers in Action</h2>`,
      description: ` <p>Let’s catch what option sellers are doing in real time:</p>

                      <ol>
                        <li>Open the <strong>Options Table</strong></li>
                        <li>Focus on strikes <strong>close to the spot price</strong></li>
                        <li>Compare <strong>Call OI vs Put OI</strong></li>
                        <li>Look for higher volume & OI on one side — that’s <strong>writing activity</strong></li>
                      </ol>

                      <div class="tip">
                        💡 <strong>Heavy Call writing = resistance. Heavy Put writing = support.</strong>
                      </div>

                      <img src="${optTableImg}" alt="Options Table" />
                  `
      },
      {
        title: `<h2>Bookmark a Setup</h2>`,
        description: ` <p>Don’t lose your perfect layout — save it for tomorrow in seconds:</p>

                      <ol>
                        <li>Load your preferred <strong>MarketProfile + Orderflow</strong> view</li>
                        <li>Click the <strong>Bookmarks</strong> button</li>
                        <li>Name it (e.g., “<strong>Morning View – NIFTY</strong>”)</li>
                        <li>Access it anytime from the <strong>Bookmarks Menu</strong></li>
                      </ol>

                      <div class="tip">
                        💡 <strong>Power tip:</strong> Save different layouts for <em>Opening Range</em> vs. <em>EOD replays</em>.
                      </div> 

                      <img src="${mpOfDualImg}" alt="Market Profile + Orderflow Charts" />
                      `
      },
      {
        title: `<h2>(Optional) Your First 3 Signals to Watch</h2>`,
        description: ` <p>Start spotting intent fast with these key cues:</p>

                      <div class="signal">
                        <strong>IB30<sup>™</sup> / IS30<sup>™</sup> Breakout →</strong> Price breaks above/below showing strong Buyers / Sellers or Big Money
                      </div>

                      <div class="signal">
                        <strong>COT Shift →</strong> A sudden flip in buyer/seller aggression
                      </div>

                      <div class="signal">
                        <strong>Trifecta Bar →</strong> A combo of buying/selling imbalances = strong signal
                      </div>`
      }
    ],
  },

  {
    title: 'Explore OrderFlow',
    subs: [
      {
        title: `<h2>Orderflow Basics</h2>`,
        description: ` <p>
                        Orderflow shows you <strong>what’s happening inside the candle</strong> — not just the price, 
                        but <strong>who’s trading</strong>, <strong>how much</strong>, and <strong>with what intent</strong>.
                      </p>

                      <p>Each bar contains a split between buyers and sellers. You’ll see:</p>

                      <ul>
                        <li>Volume traded at each price level</li>
                        <li>Whether trades hit the bid or the ask</li>
                        <li>Colored bars showing Initiative or Responsive action</li>
                      </ul>

                      <div class="tip">
                        💡 <strong>If price is rising but buyers are thinning out — that’s a trap.</strong>
                      </div>

                      <img src="${orderflowImg}" alt="Orderflow Chart" />

                      `
      },
      {
        title: `<h2>Orderflow Intro Video Series</h2>`,
        description: `
          <script src="https://player.vimeo.com/api/player.js"></script>
          
          <div style="display: grid; grid-template-columns: repeat(3, 1fr); gap: 24px; margin-top: 20px;">
            <!-- Row 1 -->
            <!-- Video 1 -->
            <div style="background-color: rgba(17, 50, 160, 0.3); border-radius: 8px; overflow: hidden; border: 1px solid rgba(63, 105, 248, 0.15); box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15); display: flex; flex-direction: column;">
              <div style="padding:56.25% 0 0 0;position:relative;">
                <iframe src="https://player.vimeo.com/video/853735125?h=c8c9f2c77f&title=0&byline=0&portrait=0" 
                  style="position:absolute;top:0;left:0;width:100%;height:100%;" 
                  frameborder="0" 
                  allow="autoplay; fullscreen; picture-in-picture" 
                  allowfullscreen>
                </iframe>
              </div>
              <div style="background-color: rgba(17, 95, 98, 0.3); padding:12px 8px; display: flex; align-items: center; justify-content: center; flex-grow: 1;">
                <h3 style="margin:0; font-size:14px; text-align:center; color: #e0e6f5; font-weight: 700; line-height: 1.4;">Introduction to Vtrender<sup>™</sup>'s Orderflow Charts</h3>
              </div>
            </div>
            
            <!-- Video 2 -->
            <div style="background-color: rgba(17, 50, 160, 0.3); border-radius: 8px; overflow: hidden; border: 1px solid rgba(63, 105, 248, 0.15); box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15); display: flex; flex-direction: column;">
              <div style="padding:56.25% 0 0 0;position:relative;">
                <iframe src="https://player.vimeo.com/video/853796900?h=c8c9f2c77f&title=0&byline=0&portrait=0" 
                  style="position:absolute;top:0;left:0;width:100%;height:100%;" 
                  frameborder="0" 
                  allow="autoplay; fullscreen; picture-in-picture" 
                  allowfullscreen>
                </iframe>
              </div>
              <div style="background-color: rgba(17, 95, 98, 0.3); padding:12px 8px; display: flex; align-items: center; justify-content: center; flex-grow: 1;">
                <h3 style="margin:0; font-size:14px; text-align:center; color: #e0e6f5; font-weight: 700; line-height: 1.4;">Market Liquidity in Orderflow</h3>
              </div>
            </div>
            
            <!-- Video 3 -->
            <div style="background-color: rgba(17, 50, 160, 0.3); border-radius: 8px; overflow: hidden; border: 1px solid rgba(63, 105, 248, 0.15); box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15); display: flex; flex-direction: column;">
              <div style="padding:56.25% 0 0 0;position:relative;">
                <iframe src="https://player.vimeo.com/video/853805750?h=c8c9f2c77f&title=0&byline=0&portrait=0" 
                  style="position:absolute;top:0;left:0;width:100%;height:100%;" 
                  frameborder="0" 
                  allow="autoplay; fullscreen; picture-in-picture" 
                  allowfullscreen>
                </iframe>
              </div>
              <div style="background-color: rgba(17, 95, 98, 0.3); padding:12px 8px; display: flex; align-items: center; justify-content: center; flex-grow: 1;">
                <h3 style="margin:0; font-size:14px; text-align:center; color: #e0e6f5; font-weight: 700; line-height: 1.4;">COT and OI in Orderflow Charts</h3>
              </div>
            </div>
            
            <!-- Row 2 -->
            <!-- Video 4 -->
            <div style="background-color: rgba(17, 50, 160, 0.3); border-radius: 8px; overflow: hidden; border: 1px solid rgba(63, 105, 248, 0.15); box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15); display: flex; flex-direction: column;">
              <div style="padding:56.25% 0 0 0;position:relative;">
                <iframe src="https://player.vimeo.com/video/853812666?h=c8c9f2c77f&title=0&byline=0&portrait=0" 
                  style="position:absolute;top:0;left:0;width:100%;height:100%;" 
                  frameborder="0" 
                  allow="autoplay; fullscreen; picture-in-picture" 
                  allowfullscreen>
                </iframe>
              </div>
              <div style="background-color: rgba(17, 95, 98, 0.3); padding:12px 8px; display: flex; align-items: center; justify-content: center; flex-grow: 1;">
                <h3 style="margin:0; font-size:14px; text-align:center; color: #e0e6f5; font-weight: 700; line-height: 1.4;">Market Dynamics with RB, IB, RS and IS</h3>
              </div>
            </div>
            
            <!-- Video 5 -->
            <div style="background-color: rgba(17, 50, 160, 0.3); border-radius: 8px; overflow: hidden; border: 1px solid rgba(63, 105, 248, 0.15); box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15); display: flex; flex-direction: column;">
              <div style="padding:56.25% 0 0 0;position:relative;">
                <iframe src="https://player.vimeo.com/video/853750725?h=c8c9f2c77f&title=0&byline=0&portrait=0" 
                  style="position:absolute;top:0;left:0;width:100%;height:100%;" 
                  frameborder="0" 
                  allow="autoplay; fullscreen; picture-in-picture" 
                  allowfullscreen>
                </iframe>
              </div>
              <div style="background-color: rgba(17, 95, 98, 0.3); padding:12px 8px; display: flex; align-items: center; justify-content: center; flex-grow: 1;">
                <h3 style="margin:0; font-size:14px; text-align:center; color: #e0e6f5; font-weight: 700; line-height: 1.4;">Volume Clusters in Orderflow Charts</h3>
              </div>
            </div>
            
            <!-- Video 6 -->
            <div style="background-color: rgba(17, 50, 160, 0.3); border-radius: 8px; overflow: hidden; border: 1px solid rgba(63, 105, 248, 0.15); box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15); display: flex; flex-direction: column;">
              <div style="padding:56.25% 0 0 0;position:relative;">
                <iframe src="https://player.vimeo.com/video/853743768?h=c8c9f2c77f&title=0&byline=0&portrait=0" 
                  style="position:absolute;top:0;left:0;width:100%;height:100%;" 
                  frameborder="0" 
                  allow="autoplay; fullscreen; picture-in-picture" 
                  allowfullscreen>
                </iframe>
              </div>
              <div style="background-color: rgba(17, 95, 98, 0.3); padding:12px 8px; display: flex; align-items: center; justify-content: center; flex-grow: 1;">
                <h3 style="margin:0; font-size:14px; text-align:center; color: #e0e6f5; font-weight: 700; line-height: 1.4;">Understanding Imbalances in Orderflow Charts</h3>
              </div>
            </div>
          </div>
        `
      },
      {
        title: `<h2>Using the Orderflow Chart</h2>`,
        description: ` <ol>
                        <li>Click <strong>Orderflow Charts</strong> from the left menu</li>
                        <li>Select your instrument (e.g., <strong>NIFTY Futures</strong>)</li>
                        <li>Read the bar like this:
                          <ul>
                            <li><strong>Green font numbers</strong> = buyers dominate</li>
                            <li><strong>Red font numbers</strong> = sellers dominate</li>
                            <li><strong>Purple bars</strong> = Initiative Selling (IS)</li>
                            <li><strong>Green bars</strong> = Initiative Buying (IB)</li>
                          </ul>
                        </li>
                      </ol>

                      <p>Hover to see exact volume. Use the split view (price in 5 vs price in 30 mins) for pressure analysis.</p>

                      <div class="tip">
                        💡 <strong>You don’t trade the bar — you trade what it reveals.</strong>
                      </div> 
                      `
      },
      {
        title: `<h2>What You See on the Orderflow Chart</h2>`,
        description: ` <p>Here’s what makes the Orderflow chart come alive:</p>

                      <ul>
                        <li><strong>Info Panel (bottom)</strong> → Volume, Max Vol of bar, COT, Open Interest — all in one place</li>
                        <li><strong>Global Volume (GV)</strong> → Tracks total volume on the chart as a Volume Profile</li>
                        <li><strong>10 Bar COT</strong> → Change in trade aggression (buying/selling shift)</li>
                      </ul>

                      <h3>Timeframes to Try:</h3>

                      <ul>
                        <li><strong>1-min</strong> → Scalping, speed analysis</li>
                        <li><strong>5-min</strong> → Intraday flow</li>
                        <li><strong>30-min</strong> → Bias + context</li>
                      </ul>

                      <div class="tip">
                        💡 <strong>Pro Tip:</strong> Try <strong>1-min</strong> for entry, <strong>5-min</strong> for confirmation, and <strong>30-min</strong> for bias.
                      </div> `
      }, 
      {
        title: `<h2>Key Orderflow Signals: IB, IS, and COT</h2>`,
        description: ` <p>We mark <strong>Initiative Buying (IB)</strong> and <strong>Initiative Selling (IS)</strong> using purple/green bars.</p>

                        <p>Here’s how to use them:</p>

                        <ul>
                          <li><strong>IB30<sup>™</sup></strong>: Buying which is initiative — strength</li>
                          <li><strong>IS30<sup>™</sup></strong>: Selling which is initiated/aggressive — aggressive players move markets</li>
                          <li><strong>COT Flip</strong>: Change in trade aggression — often precedes breakout</li>
                        </ul>

                        <div class="tip">
                          💡 <strong>Combine signals for stronger conviction</strong> — e.g., <strong>IS30<sup>™</sup> + COT flip = downside play</strong>.
                        </div> `
      },
      {
        title: `<h2>Advanced Tools: Speedo & Replay</h2>`,
        description: ` <p><strong>Speedo</strong> shows <em>pace-of-tape</em> — ideal for catching momentum bursts.<br>
                        <strong>Replay</strong> lets you revisit the day to understand market flow, volume shifts, and emotional triggers.</p>

                        <p><strong>How to use:</strong></p>

                        <ul>
                          <li>Click <strong>Replay Tool</strong> to load any day</li>
                          <li>Use <strong>Speedo</strong> during live session to sense pressure</li>
                        </ul>

                        <div class="tip">
                          💡 <strong>Traders love using Replay to build instinct.</strong> It’s the gym for your edge.
                        </div> `
      },
      {
        title: `<h2>LLTs, Illiquidity, and Divergence</h2>
`,
        description: ` <p> These advanced reads set apart reactive traders from the prepared ones:</p>

                      <ul>
                        <li><strong>LLT</strong> = Large Lot Traders — they either <em>start</em> a move or <em>finish</em> an existing one.</li>
                        <li><strong>Zero Print Bar</strong> = Signals <em>illiquidity</em> or lack of real volume. These are often excellent stop zones.</li>
                        <li><strong>COT Divergence</strong> = Price makes a new high, but COT turns <strong>red</strong> — the market is being sold into. Look for short setups.</li>
                      </ul>

                      <div class="tip">
                        💡 <strong>Look left, then right, and zoom in</strong> — you're not guessing anymore.<br>
                        You're watching the street and crossing with intent.
                      </div> `
      }

      
    ],
  },
  {
    title: 'Explore Marketprofile',
    subs: [
      {
        title: `<h2>What Is Market Profile?</h2>`,
        description: ` <p><strong>Market Profile</strong> is your <em>market structure blueprint</em> — it shows you where the market is building value, where it’s balanced, and where it’s likely to break.</p>

                      <p>Instead of just price and time, you now see:</p>

                      <ul>
                        <li>Where most trading happened (<strong>POC</strong>)</li>
                        <li>The zone that defines market acceptance (<strong>Value Area</strong>)</li>
                        <li>The early price range that sets the tone (<strong>Initial Balance</strong>)</li>
                        <li>Whether the market is consolidating or breaking structure</li>
                      </ul>

                      <div class="tip">
                        💡 <strong>When price moves outside structure, it tells a story.</strong><br>
                        And that story can be traded.
                      </div> 
                      
                      <img src="${mpOldImg}" alt="Market Profile Chart" />
                      `
      },
      {
        title: `<h2>Key Elements of Market Structure</h2>`,
        description: ` <p>These 3 elements are your <em>anchors</em> in a dynamic market:</p>

                      <h3> Point of Control (POC)</h3>
                      <p>The price where the most volume traded — the “fairest” price.<br>
                      If price stays above or below it, bias shifts.</p>

                      <h3> Value Area (VA)</h3>
                      <p>The zone where 70% of activity took place.<br>
                      <strong>VAH</strong> = Value Area High<br>
                      <strong>VAL</strong> = Value Area Low<br>
                      Price inside VA = balanced, chop.<br>
                      Price outside VA = potential shift or drive.</p>

                      <h3> Initial Balance (IB)</h3>
                      <p>The first hour’s range.<br>
                      Breakouts from IB = initiative control.<br>
                      Rejection from IB extremes = mean reversion.</p>

                      <div class="tip">
                        💡 <strong>Think of these as the walls, floor, and roof of the day’s structure.</strong>
                      </div>`
      },
      {
        title: `<h2>Reading Daily, Weekly & Composite Structures</h2>`,
        description: `
                    <p>You can view Market Profile in different timeframes to <em>zoom in or zoom out</em> of the market’s structure:</p>

                    <ul>
                      <li class="daily"><strong>Daily Profile</strong> → See each day’s auction, structure shifts</li>
                      <li class="weekly"><strong>Weekly/Monthly Profile</strong> → Observe long-term balance, buildup, and breakout zones</li>
                      <li class="composite"><strong>Composite Profile</strong> → Combine multiple sessions to find macro-level structure (big-picture POC & VA)</li>
                    </ul>

                    <div class="tip">
                      💡 <strong>Composites are like looking at the skeleton beneath the skin</strong> — they reveal hidden balance and control zones.
                    </div>`
      },
      {
        title: `<h2>Profile Shapes & Market Behaviour</h2>`,
        description: `
                    <p>Market Profile isn't just about lines — it's about <em>shape</em>, and each shape has a story:</p>

                    <ul>
                      <li class="d"><strong>D-shape</strong> → Balance. Price discovery complete. Expect range.</li>
                      <li class="b"><strong>b-shape</strong> → Longs trapped. Watch for breakdown.</li>
                      <li class="p"><strong>P-shape</strong> → Shorts trapped. Look for upside follow-through.</li>
                      <li class="trend"><strong>Trend Day</strong> → Directional conviction. Bias continues next day unless structure changes.</li>
                    </ul>

                    <div class="tip">
                      💡 <strong>Structure tells you the auction's emotional state</strong> — and that’s your edge.
                    </div>
                    `
      },

      {
        title: ` <h2>Your First Market Structure Read</h2>
`,
        description: `
                    <p>Here’s a simple checklist for reading a profile:</p>

                    <ul>
                        <li>Where is today’s POC vs yesterday’s?</li>
                        <li>Is price inside or outside the Value Area?</li>
                        <li>Has price extended beyond the Initial Balance?</li>
                        <li>What shape is the profile forming?</li>
                        <li>Is there a gap or rejection from prior structure?</li>
                      </ul>

                    <div class="tip">
                      💡 <strong>This isn’t just a chart.</strong> It’s a conversation between buyers and sellers — and you’re learning to listen in.
                    </div>

                    <p>Want to go deeper? Learn about <em>“Structure Breaks,” “Poor Highs/Lows,” and “Day Types”</em> in our <a href="#">Advanced Structure Module</a>.</p>

                    `
      },
      {
        title: '<h2>Bonus : Using Market Profile + Orderflow Together</h2>',
        description: `
                    <div class="bonus">
                        <p><strong>Combining Structure with Intent</strong> — use Market Profile and Orderflow <em>side by side</em> to see the <strong>full story</strong> of the market.</p>

                        <div class="panel-layout">
                          <p>Use the <strong>Two-Window Layout:</strong></p>
                          <ul>
                            <li><strong>Left Panel</strong> → Market Profile (MP) chart</li>
                            <li><strong>Right Panel</strong> → Orderflow (OF) chart</li>
                            <li>Same symbol, same timeframe (e.g., BANKNIFTY Futures, 5-min)</li>
                          </ul>
                        </div>
                    </div>
                    `
      }
    ],
  },
  {
    title: 'Smart Candlesticks™',
    subs: [
      {
        title: '<h2>What Are Smart Candlesticks<sup>™</sup>?</h2>',
        description: `
                      <p>These aren’t your typical red-and-green sticks.</p>

                      <p><strong>Vtrender<sup>™</sup>’s Smart Candlesticks<sup>™</sup></strong> combine:</p>

                      <ul>
                        <li>Clean candle price action</li>
                        <li>Real-time volume pressure</li>
                        <li>Structural markers like IB ranges, POC, VWAP, and COT shifts</li>
                      </ul>

                      <p>You’re no longer staring at price alone — you're seeing <strong>context + structure + intent</strong> inside each bar.</p>

                      <div class="tip">
                        💡 Think of it as price with a mind of its own — but now, you can read it clearly.
                      </div>

                      <img src="${smartCCImg}" alt="Smart Candlesticks™ Chart" />
                      `
      },

    {
      title: ' <h2>What You’re Seeing on This Chart</h2>',
      description: `
                    <p><strong>Deconstructing the Chart View</strong></p>

                    <p>From your image, here’s what each part is telling us:</p>

                    <ul>
                      <li><strong>Candles:</strong> Traditional OHLC bars (Open, High, Low, Close)</li>
                      <li><strong>IB30<sup>™</sup> / IS30<sup>™</sup> Bars:</strong> Yellow and purple bars showing initiative buying/selling</li>
                      <li><strong>Colored Volume (Below Candles):</strong>
                        <ul>
                          <li><span style="color:#00FF00;">Green bars</span> = Positive intent</li>
                          <li><span style="color:#E64F12;">Red bars</span> = Negative intent</li>
                        </ul>
                      </li>
                      <li><strong>VWAP Line (Green):</strong> Tracks fair value as it evolves</li>
                      <li><strong>Initial Balance (IB):</strong> First hour’s high and low — a critical structure zone</li>
                      <li><strong>DPOC Marker:</strong> White line marking the day’s highest traded price (Point of Control)</li>
                      <li><strong>COT Value (Top-Left):</strong> Real-time shifts in trade aggression</li>
                      <li><strong>Volume Histogram (Bottom):</strong> Displays actual trade intensity by bar</li>
                    </ul>

                    <div class="tip">
                      💡 Every candle here is filtered through the lens of <em>intent</em> — it’s not just price movement, it’s motive.
                    </div>
                                      
                      `
    },
    {
      title: ' <h2>How to Read It Like a Pro</h2>',
      description: `
                        <p><em>This chart is built for real-time narrative reading. Here's how:</em></p>

                        <ul>
                          <li>
                            <strong>Start with the POC:</strong><br>
                            → Is price <strong>accepting</strong> it, <strong>rejecting</strong> it, or <strong>moving away</strong>?
                          </li>
                          <li>
                            <strong>Watch the VWAP:</strong><br>
                            → <span>Above VWAP</span> = Bullish bias<br>
                            → <span>Below VWAP</span> = Selling control
                          </li>
                          <li>
                            <strong>Look at the Volume + COT Panel:</strong><br>
                            → <span>Green bars on down candles</span> = Absorption (buyers stepping in)<br>
                            → <span>Red bars on up candles</span> = Trap (sellers absorbing demand)
                          </li>
                          <li>
                            <strong>Follow IB Bars – Breakouts or Holds:</strong><br>
                            → Price holding outside = Initiative control<br>
                            → Rejected move = Watch for stop-losses above/below IB or IS bars
                          </li>
                        </ul>

                        <div class="tip">
                          💡 Don’t trade the candle. Trade what the market is saying <em>through</em> the candle.
                        </div>
                    
                    `
    },
    {
      title: ' <h2>How to Use It in Live Trading</h2>',
      description: `
                      <h3>Putting It to Use in the Live Market</h3>
                        <p>This view is ideal for:</p>
                        <ul>
                        <li>Bias confirmation (VWAP + POC hold)</li>
                        <li>Breakout strength checks (IB + COT)</li>
                        <li>Identifying fake moves (Volume divergence)</li>
                      <li>Entry alignment (e.g., breakout + positive COT)</li>
                    </ul>

                    <p><strong>Pro traders in the VMR use this daily for:</strong></p>
                    <ul>
                    <li>Spotting real control vs noise</li>
                    <li>Identifying intent before volume spikes</li>
                    <li>Aligning setups with the overall structure</li>
                  </ul>

                    <div class="note">
                    💡 <strong>Note:</strong> You get the best of both worlds — candle intuition + structure clarity.
                  </div>

                    <div class="divider"></div>

                      <h3>🔧 How to Load the Smart Candlestick<sup>™</sup> View</h3>
                      <p><strong>Step-by-Step:</strong></p>
                      <ul>
                      <li>From the left menu, click <strong>“Candle Line Chart”</strong></li>
                      <li>Select your instrument (e.g., <em>NIFTY Futures</em>)</li>
                      <li>From the Panel Controls at the bottom:</li>
                      <ul>
                        <li>Enable <strong>VWAP</strong></li>
                        <li>Enable <strong>Initial Balance (IB)</strong> lines</li>
                        <li>Toggle on <strong>POC</strong> and <strong>Value Area</strong> if needed</li>
                      </ul>
                      <li>Turn on the <strong>Volume COT Panel</strong> (to see trade intent)</li>
                    </ul>

                      <h3>✅ What You’ll See After Setup</h3>
                      <ul>
                      <li>Candlesticks with VWAP overlay</li>
                      <li>IB range plotted as reference lines</li>
                      <li>Live COT pressure below each candle</li>
                      <li>Optional: Open Interest display</li>
                      <li>Total volume histogram at the bottom</li>
                      <li>Top bar showing OHLC + COT values</li>
                    </ul>

                      <div class="divider"></div>

                      <h3>🧠 Pro Setup Tip</h3>
                      <p>Switch to a <strong>2-panel layout</strong> for deeper insight:</p>
                      <ul>
                      <li><strong>Left panel:</strong> Smart Candlestick<sup>™</sup> view</li>
                      <li><strong>Right panel:</strong> Orderflow Chart (same instrument and timeframe)</li>
                    </ul>
                    <p>This setup gives you both <strong>price structure</strong> and <strong>trade execution flow</strong> in a single glance.</p>

                                      
                    `
    },
    ],
  },
  {
    title: 'Explore Options',
    subs: [
      {
        title: ' <h2>Understanding the Spectrum</h2>',
        description: `
        <h2>📈 Understanding the Spectrum – Mapping the Option Range</h2>

                      <p>The <strong>Spectrum Chart</strong> is your <em>visual range finder</em> — it shows where the market is likely to stay, expand, or reject based on open interest, implied volatility, and premium activity.</p>

                      <p><strong>Spectrum is built on key principles of options positioning:</strong></p>
                      <ul>
                      <li>How traders (especially writers) structure trades around the spot</li>
                      <li>Where the largest option open interests are stacked</li>
                      <li>Whether those zones are acting like walls (resistance/support) or elastic bands (expansion zones)</li>
                    </ul>

                      <div class="tip">
                      💡 Think of Spectrum as the weather radar for the market’s option structure — it tells you if the sky is clear, cloudy, or stormy.
                    </div>

                    <img src="${spectrumImg}" alt="Spectrum" />

                      <div class="section">
                      <h3>🧭 Where to Access This:</h3>
                      <ul>
                        <li>Click <strong>‘Spectrum Charts’</strong> from the left-hand menu</li>
                        <li>Choose your instrument (e.g., <em>NIFTY</em> or <em>BANKNIFTY</em>)</li>
                        <li>View the full-day option range plotted across strikes</li>
                      </ul>
                    </div>

                      <div class="section">
                      <h3>🔍 What You See on the Spectrum:</h3>
                      <ul>
                        <li><strong>Central Spot Range</strong> → Where current price sits</li>
                        <li><strong>Upper & Lower Boundaries</strong> → Near-the-money strikes with high OI & IV</li>
                        <li><strong>Shaded Zones</strong> → Zones of possible containment (neutral range)</li>
                        <li><strong>Fading Ends</strong> → Low OI/high IV zones prone to expansion (edge breakouts)</li>
                      </ul>
                    </div>

                      <div class="section">
                      <h3>✅ How to Use It in Trading:</h3>
                      <ul>
                        <li><strong>Use Spectrum before the day starts</strong> to understand where writers are likely to defend</li>
                        <li>Combine it with <strong>VIX and volatility expectations</strong> to size the range</li>
                        <li>If price is moving toward a boundary <strong>with rising volume + COT support</strong>, you may be looking at a range break</li>
                        <li>If price stalls at a Spectrum edge <strong>and Orderflow shows absorption</strong>, it may be a trap or fade setup</li>
                      </ul>
                    </div>

                      <div class="tip">
                      💡 Combine this with <strong>NTM Volume</strong> and <strong>Gamma</strong> for full picture control.
                    </div>
                    
                    `
      },
    
      {
        title: '<h2>Using NTM VolX<sup>™</sup> – Spotting Real-Time Directional Bias</h2>',
        description: `
        <h3><strong>NTM VolX<sup>™</sup> – Reading Buyer vs Seller Action at the Frontline</strong></h3>

                      <p>
                      The <strong>NTM VolX<sup>™</sup></strong> chart shows you <strong>how much call and put volume is building around the spot</strong> — near-the-money strikes where the battle is most intense.
                    </p>

                      <p><strong><em>“Where is the real activity happening right now?”</em></strong></p>

                      <p>This is especially useful when you want to:</p>
                      <ul>
                        <li>Confirm breakout potential</li>
                        <li>Identify whether a move has <strong>volume support</strong> or not</li>
                        <li>Spot fading momentum or reversals in early stages</li>
                      </ul>

                      <div class="tip">
                      💡 <strong>Volume reveals urgency. And urgent traders are usually positioned near the money.</strong>
                      </div>

                      <img src="${ntmVolxImg}" alt="NTM VolX™ Chart" />

                      <hr>

                      <h4>🧭 Where to Access This:</h4>
                      <ul>
                        <li>Click <strong>‘NTM VolX<sup>™</sup> Charts’</strong> from the left-hand menu</li>
                        <li>Choose <strong>NIFTY</strong> or <strong>BANKNIFTY</strong></li>
                        <li>View the latest Call vs Put volumes at each NTM strike</li>
                      </ul>

                      <hr>

                      <h4>🔍 What You See on the Chart:</h4>
                      <ul>
                        <li><strong>Spot Marker</strong> → Shows where the index is trading</li>
                        <li><strong>Call Bars (Blue)</strong> → Total call volume per strike</li>
                        <li><strong>Put Bars (Purple)</strong> → Total put volume per strike</li>
                        <li><strong>Bar Color Intensity</strong> → Indicates growing or slowing volume</li>
                      </ul>

                      <hr>

                      <h4>✅ How to Use It in Trading:</h4>
                      <ul>
                        <li>If <strong>Call volume dominates</strong> near spot → traders expect price to stay <strong>capped</strong></li>
                        <li>If <strong>Put volume dominates</strong> → bearish sentiment is <strong>building</strong></li>
                        <li>If <strong>both sides are high</strong> → expect a <strong>range or volatile day</strong></li>
                      </ul>

                      <div class="tip">
                      💡 <strong>Don’t just watch price. Watch who’s getting in the ring to trade at that price.</strong>
                      </div>
        
                    `
      },
      {
        title: '<h2>NTM OI Chart – Tracking Commitment Near the Price</h2>',
        description: `
                      <h3><em>NTM OI – The Options Market's Line in the Sand</em></h3>

                      <p>If <strong>Volume</strong> tells you <em>what's happening now</em>, then <strong>Open Interest (OI)</strong> tells you <em>who’s staying in the game</em>.</p>
                      <p>The <strong>NTM OI Chart</strong> shows where traders are <em>building or reducing positions</em> around the spot price — it helps you understand what the <strong>market is defending or giving up</strong>.</p>

                      <div class="note">💡 <em>This is not just sentiment. It's commitment. And commitment is what shapes structure.</em>
                      </div>

                      <img src="${ntmOIImg}" alt="NTM OI Chart" />

                      <hr>

                      <h4>🧭 Where to Access This:</h4>
                      <ul>
                        <li>Click <strong>‘NTM OI Change Charts’</strong> in the left-hand menu</li>
                        <li>Choose your instrument (NIFTY / BANKNIFTY)</li>
                        <li>View the latest <strong>build-up or unwinding</strong> in Calls and Puts near the spot</li>
                      </ul>

                      <hr>

                      <h4>🔍 What You See on the Chart:</h4>
                      <ul>
                        <li><strong>Center Marker</strong> = Current spot</li>
                        <li><strong>Call OI Bars</strong> (Blue)</li>
                        <li><strong>Put OI Bars</strong> (Purple)</li>
                        <li><strong>Color/Highlight</strong> = Shows buildup or reduction</li>
                      </ul>
                      <div class="note"><em>Chart is updated every 3 minutes</em></div>

                      <hr>

                      <h4>✅ How to Use It in Trading:</h4>
                      <ul>
                        <li>If <strong>OI is increasing at a strike</strong>, that strike becomes more important — possibly a wall</li>
                        <li>If <strong>OI unwinds during a move</strong>, it could signal:
                          <ul>
                            <li>Traders exiting = potential breakout</li>
                            <li>Or a trap = watch Orderflow for confirmation</li>
                          </ul>
                        </li>
                        <li>Pair it with <strong>NTM Volume</strong>:
                          <ul>
                            <li><strong>High Volume + High OI</strong> = Fresh aggressive build</li>
                            <li><strong>High Volume + Dropping OI</strong> = Exit = possible reversal zone</li>
                          </ul>
                        </li>
                      </ul>

                      <p>💡 <em>You don’t want to go long into a wall of fresh Call OI. And you don’t want to short where Puts are getting added fast.</em></p>
                      `
      },

      {
        title: '<h2>Gamma Exposure – Understanding the Market’s Invisible Grip</h2>',
        description: `
                     
                     <h3><em>Gamma Exposure – Where Price Gets Pulled or Repelled</em></h3>

                      <p>Gamma is the <strong>rate of change of delta</strong>, but you don’t need to be a quant to use it.</p>
                      <p>What matters: <strong>Gamma Exposure</strong> shows how <em>dealers are likely to behave</em> as price moves — whether they’ll <strong>hedge with or against</strong> the direction.</p>
                      <p>That behavior creates <strong>sticky zones, accelerations, and stalls</strong>. It’s invisible to most, but with this chart — you see it clearly.</p>

                      <p>💡 <em>Gamma doesn’t predict price. It predicts dealer behavior — and dealers move markets.</em></p>

                      <img src="${gammaImg}" alt="Gamma Chart" />

                      <hr>

                      <h4>🧭 Where to Access This:</h4>
                      <ul>
                        <li>Click <strong>‘Gamma Charts’</strong> from the left-hand menu</li>
                        <li>Choose <strong>NIFTY</strong> or <strong>BANKNIFTY</strong></li>
                        <li>View Gamma Exposure by strike, net positive/negative zones, and spot location</li>
                      </ul>

                      <hr>

                      <h4>🔍 What You See on the Chart:</h4>
                      <ul>
                        <li>📍 <strong>Spot Marker</strong> – Where price is right now</li>
                        <li>📊 <strong>Positive Gamma Zones</strong> – Dealer behavior is hedging <em>against</em> movement = stability</li>
                        <li>🔻 <strong>Negative Gamma Zones</strong> – Dealer behavior hedges <em>with</em> movement = increased volatility</li>
                        <li>📈 <strong>Bar Strength</strong> – Size of Gamma exposure per strike</li>
                      </ul>

                      <hr>

                      <h4>✅ How to Use It in Trading:</h4>
                      <ul>
                        <li><strong>Price in Positive Gamma Zone?</strong>
                          <ul>
                            <li>→ Expect stability, chop, mean-reverting price behavior</li>
                            <li>→ Breakouts tend to fail unless fueled by external flow</li>
                          </ul>
                        </li>
                        <li><strong>Price in Negative Gamma Zone?</strong>
                          <ul>
                            <li>→ Expect larger swings, directional follow-through</li>
                            <li>→ Dealers are hedging with the move = more fuel on the fire</li>
                          </ul>
                        </li>
                        <li><strong>Watch for Spot near zero Gamma (Gamma Flip)</strong>
                          <ul>
                            <li>→ This is the transition zone — often acts like a <em>price magnet</em> or slingshot zone</li>
                          </ul>
                        </li>
                      </ul>

                      <p>💡 <em>Want to know if that breakout has fuel or friction? Check the Gamma first.</em></p>
                            
                      `
      },

      {
        title: '<h2>Writer’s Cash – Following the Money Flow in Options</h2>',
        description: `
                      <h3><em>Writer’s Cache – Where Option Sellers Are Banking or Bleeding</em></h3>

                        <p>The <strong>Writer’s Cash</strong> chart shows you how much <strong>cash flow option writers are exposed to</strong>, strike by strike.</p>

                        <p>It tracks the <strong>unrealized value of premiums</strong> sitting on both sides of the market — Calls and Puts — and highlights where writers:</p>
                        <ul>
                          <li>Are accumulating the most premium</li>
                          <li>Could face maximum pain if price breaks certain zones</li>
                          <li>Are likely to defend, trap, or reverse price</li>
                        </ul>

                        <p>💡 <em>This is the options market’s money map — follow it, and you follow intent.</em></p>

                        <img src="${wcashImg}" alt="WCash™ Chart" />

                        <hr>

                        <h4>🧭 Where to Access This:</h4>
                        <ul>
                          <li>Click <strong>‘Writer’s Cashflow’</strong> from the left-hand menu</li>
                          <li>Select your index (e.g., <strong>NIFTY</strong> or <strong>BANKNIFTY</strong>)</li>
                          <li>View strike-wise exposure of Call and Put writers in ₹ value</li>
                        </ul>

                        <hr>

                        <h4>🔍 What You See on the Chart:</h4>
                        <ul>
                          <li>📈 <strong>Bar Graph of Cash Value per Strike</strong></li>
                          <li>🟠 <strong>Call Side Premiums</strong> – Represent resistance zones</li>
                          <li>🟢 <strong>Put Side Premiums</strong> – Represent support zones</li>
                          <li>🔁 <strong>Shifts in Peaks</strong> – Suggest change in defense zones / expectations</li>
                          <li>🧮 <strong>Calculated from:</strong> Option Price × OI × Lot Size</li>
                        </ul>

                        <hr>

                        <h4>✅ How to Use It in Trading:</h4>
                        <ul>
                          <li>Look for <strong>strikes with the highest writer premium</strong> → Writers will likely defend these zones</li>
                          <li>If <strong>price moves sharply into these zones</strong>, it creates <em>pain for writers</em> = higher chance of fast moves or exits</li>
                          <li>If <strong>price stalls at a high-premium strike</strong>, it may be a writer trap — confirmed using Orderflow</li>
                          <li>Use in conjunction with:
                            <ul>
                              <li><strong>Gamma Flip</strong>: Align premium zones with volatility expectations</li>
                              <li><strong>NTM OI & Volume</strong>: Confirm if writers are holding or exiting</li>
                              <li><strong>COT Data</strong>: See if buyers are pressing into those traps</li>
                            </ul>
                          </li>
                        </ul>

                        <p>💡 <em>This chart tells you: Who has skin in the game? How much? And where will it hurt the most?</em></p>
                              
                      `
      }
    ],
  },
  // Premium Acess
  {
    title: 'Premium Access',
    subs: [
      {
        title: `<h2>Total Open Interest – The Market’s Positioning Footprint</h2>`,
        description: `
                      <h3><em>Total OI – Where the Market Is Committed</em></h3>

                      <p>
                        The <strong>Total OI chart</strong> gives you a bird’s eye view of where traders are most committed — across all strikes, both Calls and Puts.
                      </p>

                      <p>
                        This isn’t just near-the-money noise. This is <strong>the entire battlefield</strong>.
                        It shows where positions are being built, unwound, defended, or ignored — across the entire options chain.
                      </p>

                      <p>💡 <em>Total OI reveals the backbone of market structure — not just where price is now, but where exposure is stacked.</em></p>

                      <hr>

                      <h4>🧭 Where to Access This:</h4>
                      <p>Click <strong>‘Total OI’</strong> from the left-hand menu under <strong>Premium Access</strong></p>

                      <hr>

                      <h4>🔍 What You See on the Chart:</h4>
                      <ul>
                        <li>🔍 <strong>Spot Marker</strong> = current index level</li>
                        <li>📊 <strong>Call OI Bars</strong> (Right side) – commitment at resistance zones</li>
                        <li>📊 <strong>Put OI Bars</strong> (Left side) – commitment at support zones</li>
                        <li>📈 <strong>Volume overlays</strong> – highlight recent activity on top of older positioning</li>
                        <li>🔁 <strong>Chart updates with rolling OI snapshots</strong> – stay current</li>
                      </ul>

                      <hr>

                      <h4>✅ How to Use It in Trading:</h4>
                      <ul>
                        <li><strong>Strikes with high Call OI</strong> → potential supply/resistance</li>
                        <li><strong>Strikes with high Put OI</strong> → potential demand/support</li>
                        <li><strong>Watch for fresh OI builds</strong> → they tell you what’s being defended <em>today</em></li>
                        <li><strong>Watch for shrinking OI</strong> → that zone is being given up or unwound</li>
                        <li><strong>Combine with Volume and IV Curve</strong> for sharper context</li>
                      </ul>

                      <p>💡 <em>Example: If price is near a strike with massive OI on both sides — expect compression, not expansion.</em></p>
                      `
      },

      {
        title: '<h2>Total Volume – Reading the Market’s Loudest Signals</h2>',
        description: `
                      <h3><em>Total Volume – Who’s Active and Where Right Now</em></h3>

                      <p>
                        The <strong>Total Volume chart</strong> shows where <em>traders are stepping in today</em>, across all strikes.
                        This isn’t about legacy positioning — this is <strong>fresh activity</strong>, flowing in <em>right now</em>.
                      </p>

                      <p>
                        It’s the best real-time read on <strong>where the action is</strong> — and whether that action is call-heavy, put-heavy, or balanced.
                      </p>

                      <p>💡 <em>Volume shows urgency. When a strike lights up, the market is voting with its trades — not just opinions.</em></p>

                      <hr>

                      <h4>🧭 Where to Access This:</h4>
                      <p>Click <strong>‘Total Volumes’</strong> from the left-hand menu under <strong>Premium Access</strong></p>

                      <hr>

                      <h4>🔍 What You See on the Chart:</h4>
                      <ul>
                        <li>🔍 <strong>Spot Marker</strong> = current index level</li>
                        <li>🔷 <strong>Call Volume Bars</strong> (Right side) – buying/selling pressure in calls</li>
                        <li>🔶 <strong>Put Volume Bars</strong> (Left side) – pressure on the downside</li>
                        <li>💼 <strong>Bar Height</strong> = Total number of contracts traded at that strike</li>
                        <li>📊 <strong>Live View</strong> – keeps building through the session</li>
                      </ul>

                      <hr>

                      <h4>✅ How to Use It in Trading:</h4>
                      <ul>
                        <li><strong>High Call volume above spot</strong> = resistance building or breakout setup</li>
                        <li><strong>High Put volume below spot</strong> = support or breakout fade</li>
                        <li><strong>Both Calls and Puts heavy around the same strike</strong> → watch for straddle logic or range play</li>
                        <li><strong>Use in conjunction with Total OI:</strong>
                          <ul>
                            <li><strong>High Volume + Low OI</strong> = Fresh build</li>
                            <li><strong>High Volume + High OI</strong> = Intense defense</li>
                            <li><strong>High Volume + Shrinking OI</strong> = Exit or trap</li>
                          </ul>
                        </li>
                      </ul>

                      <p>💡 <em>A silent chart is a passive market. A loud chart? That’s where opportunity is waking up.</em></p>
                                          `
      },

      {
        title: `<h2>IV Curve – Seeing Risk Where Others See Strikes</h2>`,
        description: `
                      <h3><em>IV Curve – How the Market Prices Fear and Opportunity</em></h3>

                      <p>
                        The <strong>Implied Volatility (IV) Curve</strong> shows the market’s <em>expectation of future movement</em> — not in price, but in <strong>premium</strong>.
                      </p>

                      <p>
                        Each strike has its own IV, and the shape of the curve reveals:
                      </p>
                      <ul>
                        <li>Where risk is priced in</li>
                        <li>Where traders are scared</li>
                        <li>Where the market is <em>comfortable staying</em></li>
                      </ul>

                      <p>💡 <em>This is the options market’s emotion meter — shaped by what traders fear, chase, or ignore.</em></p>

                      <hr>

                      <h4>🧭 Where to Access This:</h4>
                      <p>Click <strong>‘IV Curve’</strong> under <strong>Premium Access</strong><br>Choose your instrument (NIFTY / BANKNIFTY)</p>

                      <hr>

                      <h4>🔍 What You See on the Chart:</h4>
                      <ul>
                        <li>🔍 <strong>X-Axis</strong> = Strike prices</li>
                        <li>📈 <strong>Y-Axis</strong> = Implied Volatility at each strike</li>
                        <li>💫 <strong>The Curve</strong> = Often forms a “smile” or skew based on where risk is priced</li>
                        <li>🌠 <strong>Spikes</strong> = Where traders expect large movement or impact</li>
                        <li>📊 <strong>Real-time updating</strong> based on live option pricing</li>
                      </ul>

                      <hr>

                      <h4>✅ How to Use It in Trading:</h4>
                      <ul>
                        <li><strong>Flat curve</strong> = low fear, rangebound expectations</li>
                        <li><strong>Steep skew</strong> (higher IV on one side) = market expects risk on that side</li>
                        <li><strong>Spikes at specific strikes</strong> = likely event pricing or institutional plays</li>
                        <li>
                          <strong>Compare IV to Historical Volatility (HV):</strong>
                          <ul>
                            <li><strong>If IV ≫ HV</strong> = market expects something big</li>
                            <li><strong>If IV ≪ HV</strong> = market may be underpricing risk</li>
                          </ul>
                        </li>
                      </ul>

                      <p>💡 <em>Use the IV Curve to check if you're paying too much for options — or if the other side is about to.</em></p>
                            
                      `
      },

      {
        title: `<h2>OI Visualization (OI Viz) – Mapping the Market’s Pressure Zones</h2>`,
        description: `
                      <h3><em>OI Viz – A Visual Map of Where the Market Is Bracing</em></h3>

                      <p>
                        <strong>OI Viz</strong> gives you a <em>strike-by-strike visual map</em> of Open Interest —
                        showing which levels have the strongest build-up and where the market may get pinned,
                        rejected, or stretched.
                      </p>

                      <p>
                        Unlike total OI which gives you raw values, <strong>OI Viz lets you see the battlefield</strong>.
                        Support. Resistance. Boundaries. Range compression. All of it — plotted clearly.
                      </p>

                      <p>💡 <em>It's not just data. It’s structure, seen from above.</em></p>

                      <hr>

                      <h4>🧭 Where to Access This:</h4>
                      <p>Click <strong>‘OI Viz’</strong> under <strong>Premium Access</strong><br>
                        Choose your instrument (NIFTY / BANKNIFTY)</p>

                      <hr>

                      <h4>🔍 What You See on the Chart:</h4>
                      <ul>
                        <li>🔍 <strong>Strike-wise bar layout</strong> (centered around spot)</li>
                        <li>🔷 <strong>Right Side</strong> = Call OI</li>
                        <li>🔶 <strong>Left Side</strong> = Put OI</li>
                        <li>🔍 <strong>Tall bars</strong> = Strong positioning</li>
                        <li>⚠️ <strong>Visual compression zones</strong> = High OI clustering</li>
                        <li>🔁 <strong>Live update</strong> (with OI change if enabled)</li>
                      </ul>

                      <hr>

                      <h4>✅ How to Use It in Trading:</h4>
                      <ul>
                        <li>Identify <strong>strong support and resistance</strong> zones — where OI clusters thick</li>
                        <li>Look for <strong>asymmetry</strong> in OI — one side dominating = directional bias</li>
                        <li>Combine with <strong>Volume and IV Curve</strong> to judge price behavior around that strike</li>
                        <li>Watch for <strong>sudden gaps or additions</strong> = positioning shifts</li>
                      </ul>

                      <p>💡 <em>OI Viz is the options market’s terrain map — know the hills before you charge.</em></p>

                                          
        `
      },

      {
        title: `<h2>Historical Volatility (HV) – Looking Back to Prepare Forward</h2>`,
        description: `
                      <h3><em>HV – What the Market Has Done, Not Just What It Thinks</em></h3>

                        <p>
                          While IV tells you what the market expects, <strong>Historical Volatility (HV)</strong>
                          tells you what the market actually <em>did</em>.
                        </p>

                        <p>
                          It’s the <strong>true behavior</strong> of price movement, calculated from real price
                          changes over time. HV gives you a benchmark:
                        </p>

                        <blockquote><strong>Is the market living up to its expectations or staying calm beneath the noise?</strong></blockquote>

                        <p>💡 <em>IV is opinion. HV is reality. And the gap between the two creates opportunity.</em></p>

                        <hr>

                        <h4>🧭 Where to Access This:</h4>
                        <p>
                          Click <strong>‘Historical Volatility (HV)’</strong> from the <strong>Premium Access</strong> menu<br>
                          Choose timeframe: 10-day, 20-day, 30-day, or 60-day window
                        </p>

                        <hr>

                        <h4>🔍 What You See on the Chart:</h4>
                        <ul>
                          <li>📉 <strong>HV plotted over time</strong> – rolling volatility measure</li>
                          <li>📊 Optional overlays of <strong>IV for comparison</strong></li>
                          <li>🔁 <strong>Trend lines or spikes</strong> during major events</li>
                          <li>🎯 Used to assess if premium is <strong>expensive or cheap</strong></li>
                        </ul>

                        <hr>

                        <h4>✅ How to Use It in Trading:</h4>
                        <ul>
                          <li>Compare <strong>IV vs HV</strong>:
                            <ul>
                              <li><strong>IV &gt; HV</strong> → Options are overpriced → good for <strong>selling</strong></li>
                              <li><strong>HV &gt; IV</strong> → Market is underpricing risk → good for <strong>buying</strong></li>
                            </ul>
                          </li>
                          <li><strong>Use HV trend</strong> to gauge market tone:
                            <ul>
                              <li>Rising HV → chaotic or expanding ranges</li>
                              <li>Falling HV → stable regime, likely mean-reverting setups</li>
                            </ul>
                          </li>
                          <li>Combine HV with <strong>Gamma and Total OI</strong> to see if market is about to get trapped or take off</li>
                        </ul>

                        <p>💡 <em>When the market's past is quiet but the premiums are expensive — someone’s paying up for insurance. Ask why.</em></p>

        `
      },

      {
        title: `<h2>Options Table – Strike-by-Strike Market Intelligence</h2>`,
        description: `
                      <h3><em>Options Table – The Entire Options Chain at Your Fingertips</em></h3>

                        <p>
                          The <strong>Options Table</strong> gives you a full-screen view of every strike — layered
                          with real-time data for:
                        </p>

                        <ul>
                          <li>Open Interest (OI)</li>
                          <li>Volume</li>
                          <li>Implied Volatility (IV)</li>
                          <li>Greeks (Delta, Gamma, Theta, Vega)</li>
                          <li>Premium prices</li>
                        </ul>

                        <p>This is the <strong>nerve center</strong> for traders who want to:</p>
                        <ul>
                          <li>Scan for opportunity</li>
                          <li>Spot positioning pressure</li>
                          <li>Analyze risk pricing</li>
                        </ul>

                        <p>💡 <em>It’s not just a table — it’s a live x-ray of market positioning and expectation.</em></p>

                        <hr>

                        <h4>🔍 What You See in the Table:</h4>
                        <table border="1" cellpadding="6" cellspacing="0">
                          <thead>
                            <tr>
                              <th>📘 Column</th>
                              <th>What It Tells You</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr><td>🧮 Strike Price</td><td>Base reference point</td></tr>
                            <tr><td>📊 OI & Volume</td><td>Current positioning and activity</td></tr>
                            <tr><td>⚙️ IV</td><td>Risk being priced at each strike</td></tr>
                            <tr><td>🧲 Delta</td><td>Sensitivity to underlying movement</td></tr>
                            <tr><td>🔥 Gamma</td><td>Hedge reaction to movement</td></tr>
                            <tr><td>🧘 Theta</td><td>Time decay impact</td></tr>
                            <tr><td>🌊 Vega</td><td>Sensitivity to IV change</td></tr>
                            <tr><td>💰 LTP (Call & Put)</td><td>Premium price right now</td></tr>
                          </tbody>
                        </table>

                        <p><strong>Filter or sort</strong> the table by OI, Volume, Delta, etc. for clearer insight.</p>

                        <hr>

                        <h4>✅ How to Use It in Trading:</h4>
                        <ul>
                          <li><strong>Find clusters</strong> of OI and high IV → high-pressure zones</li>
                          <li><strong>Sort by Delta ≈ 0.5</strong> to spot at-the-money activity</li>
                          <li><strong>Look for unusual Greeks</strong> (e.g., high Gamma + low IV) → fast-move potential</li>
                          <li>Combine with:
                            <ul>
                              <li><strong>Writer’s Cache</strong> to understand premium risk</li>
                              <li><strong>NTM Volume/OI</strong> to validate where action is peaking</li>
                              <li><strong>IV Curve</strong> to contextualize expensive vs cheap strikes</li>
                            </ul>
                          </li>
                        </ul>

                        <p>💡 <em>Use it for setups, hedges, traps, and exits — this is where smart money watches the board.</em></p>

                      
        `
      },

      {
        title: `<h2>Participant-Wise Positions – See Who’s Behind the Moves</h2>`,
        description: `
                      <h3><em>Participant-Wise Positions – Decode Institutional & Retail Sentiment</em></h3>

                      <p>
                        This tool gives you a breakdown of who’s doing what in the F&O market —
                        segmented by:
                      </p>

                      <ul>
                        <li><strong>FIIs</strong> – Foreign Institutional Investors</li>
                        <li><strong>DIIs</strong> – Domestic Institutions</li>
                        <li><strong>PROs</strong> – Brokers & prop desks</li>
                        <li><strong>Clients</strong> – Retail + HNIs</li>
                      </ul>

                      <p>
                        Each participant group plays differently. This view helps you
                        <strong>detect smart money behavior</strong>, <strong>herd traps</strong>, and
                        <strong>institutional shifts</strong> before the broader market reacts.
                      </p>

                      <p>💡 <em>Want to know if that breakout is real? Check who’s behind it.</em></p>

                      <hr>

                      <h4>🧑‍💼 Where to Access This:</h4>
                      <p>
                        Click <strong>‘Participant-Wise Positions’</strong> from the Premium Access menu
                      </p>

                      <hr>

                      <h4>🔍 What You See on the Chart:</h4>
                      <table border="1" cellpadding="6" cellspacing="0">
                        <thead>
                          <tr>
                            <th>📘 Metric</th>
                            <th>Insight</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr><td>📈 Long/Short Futures</td><td>Directional conviction by each group</td></tr>
                          <tr><td>📊 Options Long/Short</td><td>Strategic bias: hedging vs speculation</td></tr>
                          <tr><td>🔁 Net Change</td><td>Positioning shift over time</td></tr>
                          <tr><td>🟢/🔴 Bars or Tables</td><td>Visual cues on who’s building pressure</td></tr>
                        </tbody>
                      </table>

                      <p>Typically displayed in a comparative layout per instrument (NIFTY, BANKNIFTY)</p>

                      <hr>

                      <h4>✅ How to Use It in Trading:</h4>
                      <ul>
                        <li><strong>FII Long Futures + Call Longs</strong> → directional play</li>
                        <li><strong>PRO Put Shorts + Client Call Longs</strong> → possible bull trap</li>
                        <li><strong>DII neutral, PRO aggressive</strong> → short-term volatility expected</li>
                        <li>Look at <strong>trend in net positions</strong>, not just 1-day changes</li>
                      </ul>

                      <p>Combine with:</p>
                      <ul>
                        <li><strong>Options Table</strong> for strike alignment</li>
                        <li><strong>Gamma zones</strong> for defense zones</li>
                        <li><strong>Orderflow</strong> to validate execution pressure</li>
                      </ul>

                      <p>💡 <em>Markets are narratives. Participant-wise data shows who’s telling the story — and who’s about to flip the page.</em></p>
                                          
        `
      },

      {
        title: `<h2>FII Data Snapshot – Foreign Money’s Market Mood</h2>`,
        description: `
                      <h3><em>FII Snapshot – See Where the Big Money Is Leaning</em></h3>

                        <p>
                          This section distills the most relevant data from <strong>FII trades</strong> into a
                          sharp, easy-to-read snapshot.
                        </p>

                        <p><strong>Why it matters?</strong></p>
                        <p>
                          FIIs bring size.<br>
                          Size brings direction.<br>
                          And direction, when consistent, shapes the market’s core mood.
                        </p>

                        <p>💡 <em>They don’t chase breakouts. They build positions into noise. Your job? Read the quiet signs before the storm.</em></p>

                        <hr>

                        <h4>🧑‍💼 Where to Access This:</h4>
                        <p>
                          Click <strong>‘FII Data’</strong> under <strong>Premium Access</strong>
                        </p>

                        <hr>

                        <h4>🔍 What You See on the Chart:</h4>
                        <table border="1" cellpadding="6" cellspacing="0">
                          <thead>
                            <tr>
                              <th>📊 Metric</th>
                              <th>Interpretation</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr>
                              <td>📈 FII Net Longs in Index Futures</td>
                              <td>Bullish conviction in broader market</td>
                            </tr>
                            <tr>
                              <td>📉 FII Net Shorts in Index Futures</td>
                              <td>Caution or hedge building</td>
                            </tr>
                            <tr>
                              <td>🧲 Net Positions in Options</td>
                              <td>Call/Put ratios reveal directional tilt</td>
                            </tr>
                            <tr>
                              <td>💼 Cash Market Activity</td>
                              <td>Real buying/selling in equities</td>
                            </tr>
                            <tr>
                              <td>🔄 Day-over-Day Delta</td>
                              <td>Detects momentum shift in their strategy</td>
                            </tr>
                          </tbody>
                        </table>

                        <p>Can be paired with visual graphs or raw tables — often shown as a bar chart + net table for the day.</p>

                        <hr>

                        <h4>✅ How to Use It in Trading:</h4>
                        <ul>
                          <li><strong>Rising Futures Longs + Cash Buying</strong> → sustained trend potential</li>
                          <li><strong>Short buildup + Call Selling</strong> → caution or upcoming volatility</li>
                          <li>Watch for <strong>discrepancy</strong>:</li>
                          <ul>
                            <li>If FII data is negative but price is rising → low conviction uptrend</li>
                            <li>If FII data turns positive after consolidation → trend ignition point</li>
                          </ul>
                        </ul>

                        <p>Pair with:</p>
                        <ul>
                          <li><strong>Participant-Wise Table</strong> → confirm behavior overlap</li>
                          <li><strong>Gamma Range</strong> → know where they're defending</li>
                          <li><strong>MP/Orderflow</strong> → validate structure + conviction</li>
                        </ul>

                        <p>💡 <em>You’re not reacting to price. You’re reading positioning. That’s a professional edge.</em></p>
                              `
      }

    ]
  },

  // Free Acess
  {
    title: 'Free Access',
    subs: [
      {
        title: '<h2>Greeks Table (Bridge Table) – Fast Greek Insights at a Glance</h2>',
        description: `
                      <h3><em>Greeks Table – Your Quick Glance at Option Pressure</em></h3>

                      <p>
                        The <strong>Greeks Table</strong> gives you a streamlined view of <strong>Delta, Gamma, Theta, and Vega</strong> 
                        — across key strikes — in one clean snapshot.
                      </p>

                      <p>It’s a <strong>lightweight tool</strong> designed for:</p>
                      <ul>
                        <li>Spotting strike pressure without opening the full Options Table</li>
                        <li>Comparing ATM/NTM strikes for bias</li>
                        <li>Offering new users a soft entry into the power of Greeks</li>
                      </ul>

                      <p>💡 <em>This is your bridge from watching price… to reading pressure.</em></p>

                      <hr>

                      <h4>🧭 Where to Access This:</h4>
                      <ul>
                        <li>Click <strong>‘Greeks’</strong> under <strong>Free Access</strong></li>
                        <li>Choose the instrument (NIFTY, BANKNIFTY, or FINNIFTY)</li>
                      </ul>

                      <hr>

                      <h4>🔍 What You See on the Table:</h4>
                      <table>
                        <thead>
                          <tr>
                            <th>📯 Strike Price</th>
                            <th>📈 Delta</th>
                            <th>🧲 Gamma</th>
                            <th>⏳ Theta</th>
                            <th>🌊 Vega</th>
                            <th>💰 LTP (Call/Put)</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td>Key levels around spot</td>
                            <td>Measures directional sensitivity</td>
                            <td>Rate of Delta change = volatility exposure</td>
                            <td>Premium decay rate</td>
                            <td>IV sensitivity</td>
                            <td>Live option prices</td>
                          </tr>
                        </tbody>
                      </table>
                      <p>🧮 Focused on strikes near spot for rapid assessment</p>

                      <hr>

                      <h4>✅ How to Use It in Trading:</h4>
                      <ul>
                        <li><strong>ATM strike with rising Gamma + low Theta</strong> → price may snap through that level</li>
                        <li><strong>Deep OTM with high Vega</strong> → inflated premium, avoid buying blindly</li>
                        <li><strong>Rising Delta in Calls + rising OI in same strike</strong> → bullish pressure confirmation</li>
                        <li>Use this table to:
                          <ul>
                            <li>Filter down to 2–3 actionable strikes</li>
                            <li>Validate a setup before diving into the full Options Table</li>
                            <li>Get comfortable with Greeks without feeling overwhelmed</li>
                          </ul>
                        </li>
                      </ul>

                      <p>💡 <em>This is where many traders begin to trade smarter, not louder.</em></p>

        
                      `
      },

      {
        title: '<h2>Indices Table – Spot the Pulse of the Market</h2>',
        description: `
                      <h3><em>Indices Table – Your Index Dashboard in Real-Time</em></h3>

                        <p>
                          This tool offers a live snapshot of <strong>NIFTY, BANKNIFTY, and FINNIFTY</strong>, across:
                        </p>

                        <ul>
                          <li>Futures</li>
                          <li>Spot</li>
                          <li>Major components</li>
                        </ul>

                        <p>It’s like having a <strong>real-time market scanner</strong> showing what’s driving the move — without opening multiple charts.</p>

                        <p>💡 <em>Price moves… but internals reveal the intent.</em></p>

                        <hr>

                        <h4>🧭 Where to Access This:</h4>
                        <p>Click <strong>‘Indices’</strong> under <strong>Free Access</strong></p>

                        <hr>

                        <h4>🔍 What You See on the Table:</h4>
                        <table>
                          <thead>
                            <tr>
                              <th>Metric</th>
                              <th>Description</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr>
                              <td>📈 Index Spot</td>
                              <td>Real-time price of NIFTY/BANKNIFTY/FINNIFTY</td>
                            </tr>
                            <tr>
                              <td>💼 Futures Price</td>
                              <td>Derivative contract movement</td>
                            </tr>
                            <tr>
                              <td>🔄 Basis</td>
                              <td>Difference between Spot and Futures (premium or discount)</td>
                            </tr>
                            <tr>
                              <td>📊 Key Components</td>
                              <td>Top movers within the index (e.g., Reliance, HDFC Bank)</td>
                            </tr>
                            <tr>
                              <td>⏱️ % Change</td>
                              <td>Intraday gain/loss snapshot</td>
                            </tr>
                            <tr>
                              <td>🧭 Divergence Column</td>
                              <td>Quickly spot if Spot & Futures are misaligned</td>
                            </tr>
                          </tbody>
                        </table>

                        <p>This layout helps traders assess:</p>
                        <ul>
                          <li>Are futures leading spot (or vice versa)?</li>
                          <li>Is the move index-wide or stock-specific?</li>
                          <li>Are large caps aligned with index direction?</li>
                        </ul>

                        <hr>

                        <h4>✅ How to Use It in Trading:</h4>
                        <ul>
                          <li><strong>Futures rising faster than Spot</strong> → bullish bias may sustain</li>
                          <li><strong>Spot up, Futures flat</strong> → caution, short covering not conviction buying</li>
                          <li><strong>Large weightage stocks not moving</strong> → move may be synthetic</li>
                          <li><strong>Negative divergence in BankNifty vs Nifty</strong> → trend may lack legs</li>
                        </ul>

                        <p>Use it to:</p>
                        <ul>
                          <li>Time entries</li>
                          <li>Avoid false breakouts</li>
                          <li>Align trades with index flow</li>
                        </ul>

                        <p>💡 <em>It’s the heartbeat monitor for the index — use it before chasing a trend.</em></p>

                      `
      },
    ]

  },

  // Bookmarks and Layout
  {
    title: 'Bookmarks and Layout',
    subs: [
      {
        title: '<h2>What Are Bookmarks?</h2>',
        description: `
                      <h3><em>What Are Bookmarks?</em></h3>

                    <p><strong>Bookmarks</strong> let you <strong>save your chart setup exactly the way you want it</strong> — instruments, indicators, layouts, even timeframes.</p>

                    <p>Think of it like saving a preset view of your cockpit:</p>
                    <ul>
                      <li>You come back tomorrow morning</li>
                      <li>Click once</li>
                      <li><strong>Boom</strong> — you're ready to trade from your favorite view</li>
                    </ul>

                    <p>💡 <em>No more reloading symbols, timeframes, or toggling VWAP and IB every time.</em></p>
                      
                      `
      },

      {
        title: '<h2>Global Bookmarks – Save Any Layout</h2>',
        description: `
                      <h3><em>Global Bookmarks – Save Your Multi-Chart Setup</em></h3>

                      <p><strong>Global Bookmarks</strong> let you save <strong>any layout</strong> — across:</p>
                      <ul>
                        <li>Orderflow Charts</li>
                        <li>MarketProfile</li>
                        <li>Smart Candlesticks<sup>™</sup></li>
                        <li>Options Tools</li>
                        <li>2-panel or multi-panel views</li>
                      </ul>

                      <h4><em>How to Use:</em></h4>
                      <ol>
                        <li>Set up your preferred view — charts, symbols, and tools</li>
                        <li>Click the <strong>‘Global Bookmarks’</strong> icon</li>
                        <li>Give your view a name (e.g., <em>"NIFTY Opening Bias"</em>)</li>
                        <li>Save and access it anytime from the Bookmarks dropdown</li>
                      </ol>

                      <p>💡 <em>You can store multiple layouts for different strategies — Opening Range, Afternoon Fade, Post-News setups, etc.</em></p>

                      
                      `
      },

      {
        title: '<h2>Local Bookmarks – Save Any Chart Setup</h2>',
        description: `
                      <h3><em>MP Bookmarks – For MarketProfile Only</em></h3>

                        <p>If you work deeply with Market Profile, <strong>MP Bookmarks</strong> give you a <strong>quicker
                        way to switch Profile views</strong> without affecting other chart types.</p>

                        <h4>✅ What they save:</h4>
                        <ul>
                          <li>Selected instrument</li>
                          <li>Profile type (daily / weekly / composite)</li>
                          <li>Visual settings like split profile, POC, VA</li>
                        </ul>

                        <h4><em>Use Case Examples:</em></h4>
                        <ul>
                          <li>"NIFTY Daily TPO"</li>
                          <li>"BANKNIFTY Composite + Weekly Bias"</li>
                          <li>"FinNifty VA Break Scanner"</li>
                        </ul>

                        <p><strong>Note:</strong> These are <em>specific to MarketProfile</em> — they don’t store Orderflow
                        or Options data overlays.</p>

                        <p>💡 <em>Think of MP Bookmarks as your custom MP templates.</em></p>
                      `
      },
      {
        title: '<h2>Pro Bookmark Tips & Layout Power Moves</h2>',
        description: `
                      <h3><em>Pro Tips: Using Bookmarks Like a Trading Desk</em></h3>

                        <p>Here’s how our top traders use Bookmarks:</p>

                        <ul>
                          <li>☑️ <strong>Opening View</strong> → Save your go-to premarket bias setup</li>
                          <li>☑️ <strong>Post-Lunch Setup</strong> → Use a different chart layout for afternoon volatility</li>
                          <li>☑️ <strong>Instrument-Specific Views</strong> → Create custom views for BANKNIFTY, FINNIFTY, and stock futures</li>
                        </ul>
                      `
      }
    ],
  },
];